// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:34:01.338Z
// Property: Neo at Ten (ID: 5191322281443328)
// Collections: 24 amenities, 32 floorplans (live), 17 photos, 82 POIs, 5 reviews, 3 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5191322281443328",
  "property_external_id": "4960172",
  "property_zillow_url": "https://www.zillow.com/b/14805-grisby-rd-houston-tx-9hRrjW/",
  "property_apartments_url": "https://www.apartments.com/neo-at-ten-houston-tx/5sqxz7q",
  "property_google_business_url": "https://www.google.com/maps/place/H6+Apartments/@29.7820685,-95.6474934,17z/data=!3m1!4b1!4m5!3m4!1s0x8640dbe1d360a1d1:0xbc5432b7c851e2d2!8m2!3d29.7820685!4d-95.6452994",
  "property_linkedin_url": null,
  "property_hubspot_id": "8007438931",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "neo-at-ten",
  "property_name": "Neo at Ten",
  "property_website_url": "https://www.neoatten.com/",
  "property_domain": "https://www.neoatten.com/",
  "property_address": "14805 Grisby Rd",
  "property_full_address": "14805 Grisby Rd, Houston, TX 77079",
  "property_address_1": "14805 Grisby Rd",
  "property_address_2": null,
  "property_address_city": "Houston",
  "property_address_state": "TX",
  "property_address_zip_full": "77079-2351",
  "property_address_zip": "77079",
  "property_address_country": "US",
  "property_address_county": "Harris County",
  "property_neighborhood_address": "Energy Corridor",
  "property_address_latitude": "29.7818386",
  "property_address_longitude": "-95.64558799999999",
  "property_email": "neo@alapts.com",
  "property_phone": "(281) 556-5006",
  "property_call_tracking_phone": "346-594-9312",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern Energy Corridor living with room to recharge.</strong> Explore polished one- and two-bedroom <a href=\"/floor-plans\">floor plans</a> near I-10 and Highway 6, with elevated finishes, private outdoor space, and resort-inspired amenities designed to make West Houston feel like home.</p>",
  "property_long_description": "<p><strong>Modern Energy Corridor living with room to recharge.</strong> At Neo at Ten, you get a polished West Houston apartment experience moments from I-10 and Highway 6—close to major Energy Corridor employers, Grisby Road dining, and everyday conveniences without losing your connection to green space.</p><p>Choose from one- and two-bedroom <a href=\"/floor-plans\">floor plans</a> designed with stainless steel appliances, quartz or granite countertops, 9’ ceilings, USB outlets, in-home washer and dryer, spacious closets, and a private patio or balcony. Beyond your door, <a href=\"/amenities\">resort-inspired amenities</a> bring the day into focus: a pool, 24-hour fitness center, resident lounge with coffee bar, business center with conference rooms, outdoor kitchen, hibachi courtyard dining, bark park, EV charging, package system, and direct-access garage parking.</p><p>When you’re ready to head out, George Bush Park, Terry Hershey Park trails, Topgolf, Watson’s House of Ales, Lomonte’s, and Eldridge Parkway favorites are all part of your <a href=\"/neighborhood\">Energy Corridor neighborhood</a>.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019d02ee-7ae4-74b9-8f31-41149ab557e8.webp",
  "property_featured_image_media": {
    "alt_text": "Modern apartment complex courtyard with artificial turf, outdoor seating, and tables.",
    "public_id": "019d02ee-7ae4-74b9-8f31-41149ab557e8",
    "storage_key": "property/5191322281443328/019d02ee-7ae4-74b9-8f31-41149ab557e8.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "293",
  "property_year_built": "2016",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.15017064846417",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $300 / pet\nMonthly Pet Rent $25 / pet\nApplication Approval Fee Starting At $300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8853004.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://neoatten.loftliving.com/login",
  "property_apply_now_url": "https://8853004.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e6ff5-b666-74f5-a789-f2f5c30d0aa5.webp",
  "property_primary_logo_media": {
    "alt_text": "Neo Ten Premier Apartments logo",
    "public_id": "019e6ff5-b666-74f5-a789-f2f5c30d0aa5",
    "storage_key": "property/5191322281443328/019e6ff5-b666-74f5-a789-f2f5c30d0aa5.webp",
    "width": 1307,
    "height": 946
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e6ff5-a463-75d9-9aa5-fa2577eee905.webp",
  "property_secondary_logo_media": {
    "alt_text": "Neo Ten logo",
    "public_id": "019e6ff5-a463-75d9-9aa5-fa2577eee905",
    "storage_key": "property/5191322281443328/019e6ff5-a463-75d9-9aa5-fa2577eee905.webp",
    "width": 1307,
    "height": 946
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e6ff5-b686-7266-ba03-7c22bad99f3f.webp",
  "property_icon_media": {
    "alt_text": "NeoTen property logo",
    "public_id": "019e6ff5-b686-7266-ba03-7c22bad99f3f",
    "storage_key": "property/5191322281443328/019e6ff5-b686-7266-ba03-7c22bad99f3f.webp",
    "width": 1827,
    "height": 1827
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e6ff5-b686-7266-ba03-7c22bad99f3f.webp",
  "property_fav_icon_media": {
    "alt_text": "NeoTen property logo",
    "public_id": "019e6ff5-b686-7266-ba03-7c22bad99f3f",
    "storage_key": "property/5191322281443328/019e6ff5-b686-7266-ba03-7c22bad99f3f.webp",
    "width": 1827,
    "height": 1827
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e6ff5-a8b3-71a0-af87-a44be3a2e661.webp",
  "property_mono_white_logo_media": {
    "alt_text": "NeoTen Premier Apartments logo",
    "public_id": "019e6ff5-a8b3-71a0-af87-a44be3a2e661",
    "storage_key": "property/5191322281443328/019e6ff5-a8b3-71a0-af87-a44be3a2e661.webp",
    "width": 1307,
    "height": 946
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e6ff5-a42f-7004-ac74-35fd76ad4450.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Neo ten premier apartments logo",
    "public_id": "019e6ff5-a42f-7004-ac74-35fd76ad4450",
    "storage_key": "property/5191322281443328/019e6ff5-a42f-7004-ac74-35fd76ad4450.webp",
    "width": 1307,
    "height": 946
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#5d55c1",
  "property_secondary_color": "#a3a9ad",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#231f20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "575 - 1444",
  "property_sqft_min": "575",
  "property_sqft_max": "1444",
  "property_price_range": "1131.16 - 1951.16",
  "property_price_min": "1131.16",
  "property_price_max": "1951.16",
  "property_available_units": 23,
  "property_facebook_url": "https://www.facebook.com/NeoatTenApts",
  "property_instagram_url": "https://www.instagram.com/NeoatTenApartments",
  "property_twitter_url": "https://twitter.com/h6apartments",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ0aFg0-HbQIYR0uJRyLcyVLw",
  "property_youtube_url": "https://www.youtube.com/watch?v=r2atjvt8iqc",
  "property_yelp_url": "https://www.yelp.com/biz/neo-at-ten-houston",
  "property_tiktok_url": "https://www.tiktok.com/@neoatten",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Amenities with Energy Corridor momentum.</strong> Start with a 24-hour fitness center, unwind by the pool, meet at the coffee bar, or focus in the business center with conference rooms. Outdoor perks include a grilling kitchen, hibachi courtyard dining, and a bark park, while EV charging, package lockers, direct-access garage parking, elevator access, and refined in-home finishes add everyday ease.</p>",
  "property_home_floorplans_blurb": "<p><strong>One- and two-bedroom layouts with polished Energy Corridor style.</strong> Explore floor plans with 9’ ceilings, in-home washer and dryer, walk-in closets, and private patios or balconies. Stainless steel appliances, quartz or granite countertops, and designer cabinetry add everyday refinement, while select homes offer Nest thermostats, garden tubs, walk-in showers, or dual-sink vanities.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at Neo at Ten.</strong> Preview bright one- and two-bedroom apartments with stainless steel appliances, stone countertops, designer cabinetry, and patios or balconies. Then picture the resort-inspired pool, 24-hour fitness center, coffee bar lounge, grilling and hibachi areas, garage parking, package access, and pet-friendly spaces—all captured in the full gallery.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Energy Corridor ease, West Houston green space.</strong> Neo at Ten puts local dining at Grisby Square, Buffalo Bayou trails at Terry Hershey Park, and CityCentre shopping, movies, and restaurants within easy reach. With I-10, Highway 6, and Addicks Park &amp; Ride nearby, the map opens up fast—while cafés, errands, offices, and outdoor escapes stay close to home.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents highlight the service.</strong> Feedback for Neo at Ten often centers on responsive maintenance, timely work orders, and a team that helps keep the community clean and well cared for. From “excellent customer service” to quick attention when requests come up, reviews offer a firsthand look at everyday living in Houston’s Energy Corridor.</p>",
  "property_neighborhood_blurb": "<p><strong>West Houston, mapped to your rhythm.</strong> From Neo at Ten, the Energy Corridor feels connected without losing its green, open-air feel. Stroll over to Grisby Square for local favorites like Watson’s House of Ales or Lomonte’s, plan a trail break along Buffalo Bayou at Terry Hershey Park, or head east to CityCentre for shopping, dinner, movies, and weekend plans.</p><p>I-10, Highway 6, and nearby Addicks Park &amp; Ride keep more of Houston within easy reach, while major Energy Corridor offices, cafés, errands, and outdoor escapes stay close to home. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the neighborhood fits around your day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that keep pace with your day.</strong> At Neo at Ten, you can move from a workout in the 24-hour fitness center to a poolside reset, a coffee-bar catch-up, or a focused session in the business center with conference rooms—without leaving the community. Outdoors, the grilling kitchen and hibachi courtyard dining area give you more ways to enjoy Houston’s Energy Corridor, while the bark park adds a dedicated space for pets.</p><p>Everyday convenience is built in, too, with direct-access garage parking, EV charging stations, elevator access, package lockers, and online resident services. Inside your apartment, polished finishes like stainless steel appliances, quartz or granite countertops, designer cabinetry, LED lighting, USB outlets, in-home laundry, and a private patio or balcony make the routine feel refined. See more spaces in the <a href=\"/gallery\">photo gallery</a> or compare layouts on the <a href=\"/floor-plans\">floor plans</a> page.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Neo at Ten.</strong> Choose a polished one- or two-bedroom apartment with 9’ ceilings, stainless steel appliances, quartz or granite countertops, in-home laundry, and a private patio or balcony—all in a West Houston setting moments from I-10, Highway 6, and Energy Corridor conveniences.</p>",
  "property_contactus_blurb": "<p><strong>Questions? We’re here to help.</strong> Contact the Neo at Ten leasing team to learn more about our one- and two-bedroom apartments, modern finishes, and Energy Corridor location near I-10 and Highway 6. Reach out today for details or directions to our West Houston community.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Neo at Ten?</strong> Start here for quick answers about the community, leasing, apartment features, amenities, and everyday living in the Energy Corridor. If you need a little more detail, the leasing team is happy to help you find what you need.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits the way you live.</strong> Neo at Ten offers a deep collection of one- and two-bedroom apartments in the Energy Corridor, from streamlined one-bedrooms to roomier two-bedroom plans with separated suites and flexible living space. As you compare available options below, look for details that make each home feel polished and practical: stainless steel appliances, quartz or granite countertops, designer cabinetry, 9’ ceilings, in-home washer and dryer, spacious walk-in closets, and a private patio or balcony. Select layouts add Nest thermostats, garden tubs, walk-in showers, or dual-sink vanities for an extra level of comfort. When a floor plan catches your eye, check current availability, browse the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_gallery_blurb": "<p><strong>See the details that make Neo at Ten feel polished from the first look.</strong> Browse the gallery for sunlit one- and two-bedroom apartments with clean-lined kitchens, stainless steel appliances, stone countertops, designer cabinetry, and private patios or balconies that extend your space outdoors.</p><p>Then follow the camera through the community: water shimmering at the resort-inspired pool, a sleek fitness center ready around the clock, a lounge with coffee bar, and open-air dining areas with grilling and hibachi tables. You’ll also spot everyday conveniences like garage parking, package access, and spaces designed for work, downtime, and pets in Houston’s Energy Corridor. Like what you see? Explore more <a href=\"/amenities\">amenity details</a>, compare <a href=\"/floor-plans\">available floor plans</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Neo at Ten in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Neo at Ten on the map.</strong> See available apartments near I-10 and Highway 6, then zoom out to discover Energy Corridor dining, everyday conveniences, and nearby green space—all around polished West Houston living with room to recharge.</p>",
  "property_pets_blurb": "<p><strong>Bring the paws, toys, and treat jar.</strong> Neo at Ten makes pet-friendly apartment living feel easy, with cats and dogs welcome, no weight limit, and an on-site <a href=\"/amenities\">bark park</a> for quick exercise close to your door. After a walk, head back to a home with practical comforts like in-home laundry, spacious closets for leashes and supplies, and a private patio or balcony in many layouts.</p><p>Located in Houston’s Energy Corridor, Neo at Ten also keeps everyday pet routines convenient, with nearby options for supplies, grooming, and veterinary care. Review the policy details below for fees and breed guidelines, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how your pet’s routine can fit right in.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Energy Corridor lifestyle you love.</strong> Invite a friend to discover polished West Houston living at Neo at Ten, with modern one- and two-bedroom apartments, space to recharge, and resort-inspired amenities moments from I-10, Highway 6, dining, conveniences, and green space.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Neo at Ten.</strong><br>Pay rent, submit maintenance requests, and manage your account in one convenient place—so you can get back to polished West Houston living with more room to recharge.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents notice most.</strong> Reviews for Neo at Ten often point to the people behind the property—responsive service, attentive maintenance, and a team that helps keep the community looking its best. Residents call out timely work orders, a clean setting, and customer care that makes day-to-day apartment living feel easier.</p><p>As you browse the feedback, you’ll see praise for “excellent customer service,” “the community is kept clean,” and maintenance requests handled quickly. Use these firsthand perspectives to get a clearer sense of Neo at Ten in Houston’s Energy Corridor.</p>",
  "property_created_at": "1752256316621",
  "property_scheduletour_blurb": "<p><strong>See Energy Corridor living up close.</strong> Tour Neo at Ten and picture polished finishes, 9’ ceilings, spacious closets, and a private patio or balcony—plus resort-inspired spaces made for recharging. Schedule your visit today and experience how West Houston convenience and modern apartment comfort come together.</p>",
  "property_thankyou_blurb": "<p><strong>Thanks—we received your inquiry.</strong><br>Neo at Ten’s leasing team will be in touch soon. In the meantime, picture modern Energy Corridor living with polished one- and two-bedroom apartments, smart finishes, resort-inspired spaces, and room to recharge near I-10, Highway 6, and nearby green space.</p>",
  "property_virtualtours_blurb": "<p><strong>Preview the feel of Neo at Ten before you arrive.</strong> Step inside the virtual tours and move at your own pace through the spaces that matter most: the community tour, a one-bedroom apartment tour, and a two-bedroom apartment tour. Zoom in on polished kitchen finishes, open living areas, natural light, in-home laundry, and the kind of storage and everyday flow that can be hard to judge from photos alone.</p><p>Then explore the community experience—from poolside scenes to resident spaces designed for work, workouts, and downtime in Houston’s Energy Corridor. If a tour sparks ideas for your next move, compare <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule an in-person tour</a> to see Neo at Ten from every angle.</p>",
  "property_copyright": "2025 All Rights Reserved. Neo at Ten",
  "property_seo_title_home": "Neo at Ten | Apartments in Houston, TX",
  "property_seo_description_home": "Discover the perfect blend of comfort and convenience at Neo at Ten in Houston, TX! Choose from spacious one and two-bedroom floor plans and enjoy exceptional amenities, including a refreshing pool, state-of-the-art fitness center, and on-site retail. With features like a clubhouse, 24-hour access, pet-friendly spaces, and planned social activities, your ideal apartment experience awaits. Explore our charming vintage building complete with modern conveniences like online services, package delivery, and a cozy media center. **Find your new home today!**",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Houston, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at Neo at Ten in Houston, TX! Explore our thoughtfully designed floor plans featuring one and two-bedroom options. Whether you seek cozy comfort or spacious elegance, we have the perfect apartment home for you. Browse our available options today and make Neo at Ten your new home!",
  "property_seo_title_amenities": "Amenities | Houston, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover your new home at Neo at Ten in Houston, TX! Choose from spacious one and two-bedroom floor plans and enjoy unparalleled amenities including a sparkling pool, fully-equipped fitness center, and vibrant clubhouse. Experience the convenience of on-site retail, key fob entry, and 24-hour access, alongside thoughtful features like a pet play area, media center, and planned social activities. Explore our amazing community amenities and apartment features today to elevate your lifestyle!",
  "property_seo_title_gallery": "Gallery | Apartments in Houston, TX",
  "property_seo_description_gallery": "Explore Neo at Ten in Houston, TX—where modern comfort meets classic charm! Browse our stunning photo gallery showcasing our spacious one and two-bedroom floor plans, complete with amenities like a refreshing pool, state-of-the-art fitness center, and pet-friendly play areas. Experience the convenience of 24-hour access, onsite retail, and engaging social activities. Imagine unwinding at our vintage building’s sundeck or enjoying movie nights in the media center. Picture yourself living here and discover your perfect home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Neo at Ten Apartments",
  "property_seo_description_virtualtours": "Discover your perfect home at Neo at Ten in Houston, TX! Explore our spacious one and two-bedroom floor plans with a virtual tour of our vibrant community. Take a virtual tour of our apartments for rent today and find your ideal living space!",
  "property_seo_title_interactivemap": "Interactive Map | Neo at Ten Apartments",
  "property_seo_description_interactivemap": "Explore your new home at Neo at Ten in Houston, TX! Choose from spacious one and two-bedroom floor plans tailored to suit your lifestyle. Enjoy resort-style amenities including a sparkling pool, fitness center, and on-site retail. Stay connected with 24-hour access, Wi-Fi, and online services. Our interactive community map allows you to view available apartments, compare pricing, and find the perfect fit for you. Don't miss out on planned social activities, a pet play area, and more. Start your journey to elegant living at Neo at Ten today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Houston, TX",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Neo at Ten in Houston, TX! Explore our one and two bedroom apartment floor plans and see what's nearby, from local favorites to essential amenities. Experience the best of apartment living and community convenience.  Explore our neighborhood today!",
  "property_seo_title_contact": "Contact Us | Neo at Ten",
  "property_seo_description_contact": "Discover your ideal living space at Neo at Ten in vibrant Houston, TX! Our community offers a range of thoughtfully designed apartment floor plans, including one and two-bedroom options tailored to your lifestyle. Have questions? Contact our friendly leasing team today to learn more about our offerings and make Neo at Ten your new home!",
  "property_seo_title_faqs": "FAQs | Apartments in Houston, TX",
  "property_seo_description_faqs": "Explore the vibrant lifestyle at Neo at Ten in Houston, TX! Discover our range of floor plans, including one and two-bedroom apartments, all featuring exceptional amenities like a refreshing pool, state-of-the-art fitness center, and a welcoming clubhouse. Enjoy 24-hour access, on-site retail, and social activities designed just for you. Curious about our community? Browse our FAQs page for answers to your most pressing questions and find out why Neo at Ten is your ideal home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Houston, TX",
  "property_seo_description_reviews": "Discover the exceptional living experience at Neo at Ten in Houston, TX! Explore our diverse floor plans, featuring spacious one and two-bedroom apartments, designed to suit your lifestyle. Enjoy top-notch amenities like a refreshing pool, a state-of-the-art fitness center, and a welcoming clubhouse. With conveniences such as controlled access, package service, and 24-hour maintenance on-site, you’ll feel right at home. Don’t just take our word for it—see what our residents have to say about life at Neo at Ten! Join our vibrant community today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Houston, TX",
  "property_seo_description_applynow": "Discover your ideal living space at Neo at Ten in Houston, TX! Choose from spacious one and two-bedroom floor plans adorned with modern amenities. Enjoy a vibrant lifestyle with a luxurious pool, fitness center, and inviting clubhouse. Benefit from on-site retail, 24-hour access, and tailored services like dry cleaning and package delivery. With planned social activities, pet-friendly areas, and relaxing courtyards, there's something for everyone. Explore all the features that make Neo at Ten the perfect place to call home. Find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Neo at Ten",
  "property_seo_description_residentaccess": "\"Welcome to the Resident Access Login for Neo at Ten in Houston, TX. Effortlessly manage your apartment living experience: pay rent, schedule maintenance, and access essential resident services all in one convenient portal. Log in today!\"",
  "property_seo_title_referafriend": "Refer A Friend | Neo at Ten",
  "property_seo_description_referafriend": "\"Discover the joy of community living at Neo at Ten in Houston, TX! Great friends make great neighbors—refer a friend today and unlock exclusive benefits. Join us in creating a vibrant and welcoming atmosphere. Your next adventure awaits!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Neo at Ten",
  "property_seo_description_scheduletour": "Discover your new home at Neo at Ten in Houston, TX! Experience modern living with top-notch amenities and a vibrant community atmosphere. Ready to see it for yourself? Schedule a tour of our community today and take the first step towards your dream apartment!",
  "property_seo_title_privacy": "Privacy Policy | Neo at Ten",
  "property_seo_description_privacy": "\"Discover peace of mind at Neo at Ten in Houston, TX. Our Privacy Policy outlines how we safeguard your personal information and ensure a secure living experience. View our privacy policy to learn more!\"",
  "property_seo_title_accessibility": "Website Accessibility | Neo at Ten",
  "property_seo_description_accessibility": "Discover Neo at Ten in Houston, TX, where we prioritize accessibility for all residents and visitors. Our commitment to digital inclusion ensures that everyone can fully enjoy our apartment community. Explore our Accessibility Statement and see how we strive to create an inviting and accessible living environment. Join us at Neo at Ten today!",
  "property_seo_title_sitemap": "Sitemap | Neo at Ten",
  "property_seo_description_sitemap": "\"Discover the ideal living experience at Neo at Ten in Houston, TX! Explore our comprehensive sitemap to easily navigate our vibrant community, stunning amenities, and available apartments. Your perfect home is just a click away!\"",
  "property_seo_title_thankyou": "Thank You | Neo at Ten",
  "property_seo_description_thankyou": "\"Thank you for submitting your information to Neo at Ten in Houston, TX! Our team will reach out shortly to help you discover your new home. Stay tuned for updates about our vibrant community and exceptional amenities!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320104",
  "amenities": [
    {
      "id": "custom_cdb0eba8-3fb9-4743-88eb-718fb4daa82a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ab531bd4-972d-49ae-a520-33f63fa54d96",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000607",
      "title": "Business Center",
      "amount": "0.0000",
      "description": "WFH Business Center w/ Conference Room",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_91131c93-fb0b-4245-a656-8133fe27ef70",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000614",
      "title": "Clubhouse",
      "amount": "0.0000",
      "description": "Resident Clubhouse",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d2d854e9-fb12-4d61-8c83-bd8438b83e48",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Quartz and Granite Countertops*",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d33bd758-2c9b-4a3c-b506-08c0a6bfa2d7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000622",
      "title": "Courtyard",
      "amount": "0.0000",
      "description": "Courtyard w/ Zen Garden",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_633c4485-6d55-4fe7-a9a6-7ae424c83e98",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000625",
      "title": "Digital Thermostats",
      "amount": "0.0000",
      "description": "NEST Systems*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b70dbe91-ac9b-4708-bdbf-481913b8bcc4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "24-Hour Cardio & Strength Training Gym",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cc8818ce-1a0a-4ab0-a970-80e11c764573",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Grilling Area w/ BBQ Pit",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8f89cfe7-fac9-449d-8946-71f973dd85d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood-Style Vinyl Flooring*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_811e7aff-a470-451b-b134-b71ede75454e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_87768911-7202-41b8-9df6-cbb336011443",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000652",
      "title": "Kitchen Islands",
      "amount": "0.0000",
      "description": "Modern Kitchen Islands*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e5cd0d5f-268f-4c32-9e8e-79380c228706",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e64a526e-a541-4f28-96bc-9cbcca07d4a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000662",
      "title": "Outdoor Kitchen",
      "amount": "0.0000",
      "description": "Outdoor Kitchen & Social Areas",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0cc98a01-e898-4208-b9bd-a7571b36ccfd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios or Balconies*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5f2af14a-810e-41f2-b219-7eafc66c6554",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000665",
      "title": "Package System",
      "amount": "0.0000",
      "description": "Resident Concierge Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c6e5e416-c501-4b77-91d9-58f652ed34f9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000667",
      "title": "Parking",
      "amount": "0.0000",
      "description": "Reserved Covered Parking Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bbfbece6-74a7-4778-b18d-b3bb67be3aaf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Style Pool w/Water Features",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ecd267ce-6882-49e2-8332-e40bd5488486",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a6176b35-d228-4d63-a70b-32f668c04bae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000688",
      "title": "Sundeck",
      "amount": "0.0000",
      "description": "In-Pool Lounges & Sun Deck",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_92a33aef-31c5-4321-91cc-1497bae579bc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "9 or 10 Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_30880877-2b4b-427e-8394-deb7876b7c51",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Backsplashes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d46bbafa-d878-4f06-9812-665cc76613ce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000697",
      "title": "Tubs",
      "amount": "0.0000",
      "description": "Garden Soaking Tubs",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_83af5284-fe6f-4d55-b08e-fa23db2f91cb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "USB Outlets in Kitchens",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ee965036-fe10-4f28-82c8-10c9d04a7745",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Full-Size Washers & Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_7e4ea15d-d19a-41a6-a5f5-ece91d748fc3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e89a5-7bd2-70ab-9002-48287b344b4c.webp",
      "image_media": {
        "alt_text": "Modern apartment courtyard with artificial turf, outdoor seating, and umbrellas.",
        "public_id": "019e89a5-7bd2-70ab-9002-48287b344b4c",
        "storage_key": "property/5191322281443328/019e89a5-7bd2-70ab-9002-48287b344b4c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our beautiful community courtyard, featuring lush artificial turf, comfortable seating areas, and shaded tables perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Modern apartment courtyard with artificial turf, outdoor seating, and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a9798b46-a215-4d27-adeb-db7897837f02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e89a5-7735-744a-a038-b86ff51cfd5b.webp",
      "image_media": {
        "alt_text": "Luxurious bedroom with a tufted headboard, plush bedding, and a vanity desk.",
        "public_id": "019e89a5-7735-744a-a038-b86ff51cfd5b",
        "storage_key": "property/5191322281443328/019e89a5-7735-744a-a038-b86ff51cfd5b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover comfort and style in our beautifully appointed bedrooms, featuring elegant decor and ample space for relaxation.",
      "link": "",
      "alt_text": "Luxurious bedroom with a tufted headboard, plush bedding, and a vanity desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6bf716b7-370e-4df1-9dd2-092b4c73c978",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e89a5-7777-701f-93b6-5082ede28fdb.webp",
      "image_media": {
        "alt_text": "Modern gym with treadmills, ellipticals, and exercise bikes, featuring purple accent walls and large windows.",
        "public_id": "019e89a5-7777-701f-93b6-5082ede28fdb",
        "storage_key": "property/5191322281443328/019e89a5-7777-701f-93b6-5082ede28fdb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with a variety of cardio machines to help you achieve your health goals.",
      "link": "",
      "alt_text": "Modern gym with treadmills, ellipticals, and exercise bikes, featuring purple accent walls and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fb4a6b67-6806-4d8c-b88a-c01f86c1af60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e89a5-76db-74d9-a20b-b8d210ea0f71.webp",
      "image_media": {
        "alt_text": "Kitchen island with sink and dishwasher, view of dining area and living room.",
        "public_id": "019e89a5-76db-74d9-a20b-b8d210ea0f71",
        "storage_key": "property/5191322281443328/019e89a5-76db-74d9-a20b-b8d210ea0f71.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen with granite countertops and island, opening to a spacious dining and living area.",
      "link": "",
      "alt_text": "Kitchen island with sink and dishwasher, view of dining area and living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3767b329-74f6-4dd5-9c9e-455101ef615b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e89a5-68b4-763f-92e2-0f604d5696db.webp",
      "image_media": {
        "alt_text": "Courtyard seating area with chairs and a fire pit, surrounded by apartment buildings and landscaping.",
        "public_id": "019e89a5-68b4-763f-92e2-0f604d5696db",
        "storage_key": "property/5191322281443328/019e89a5-68b4-763f-92e2-0f604d5696db.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed courtyard, featuring comfortable seating, a fire pit, and lush landscaping. The perfect spot to enjoy the outdoors.",
      "link": "",
      "alt_text": "Courtyard seating area with chairs and a fire pit, surrounded by apartment buildings and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a6f1354b-4f4a-44a3-b110-0db92b183a45",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e89a5-66ff-725c-94e7-93e3ad81e4b5.webp",
      "image_media": {
        "alt_text": "Elegant lobby with modern seating, artwork, and a view of the pool area.",
        "public_id": "019e89a5-66ff-725c-94e7-93e3ad81e4b5",
        "storage_key": "property/5191322281443328/019e89a5-66ff-725c-94e7-93e3ad81e4b5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience sophisticated living in our stunning lobby, featuring contemporary design and access to resort-style amenities.",
      "link": "",
      "alt_text": "Elegant lobby with modern seating, artwork, and a view of the pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ae816127-2159-44ea-b329-1abc0f472397",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e89a5-6973-752d-b103-9f4c42e12376.webp",
      "image_media": {
        "alt_text": "Modern living room and open-concept kitchen with a gray sofa, red pillows, and stainless steel appliances.",
        "public_id": "019e89a5-6973-752d-b103-9f4c42e12376",
        "storage_key": "property/5191322281443328/019e89a5-6973-752d-b103-9f4c42e12376.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience luxurious living in this spacious apartment featuring a stylish living area and a fully equipped open-concept kitchen with a breakfast bar.",
      "link": "",
      "alt_text": "Modern living room and open-concept kitchen with a gray sofa, red pillows, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b805d7c-82ca-46e2-862c-552d1c7854a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e89a5-6b06-77db-b01a-00f8caf6280f.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019e89a5-6b06-77db-b01a-00f8caf6280f",
        "storage_key": "property/5191322281443328/019e89a5-6b06-77db-b01a-00f8caf6280f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and vibrant umbrellas. The perfect place to relax and unwind.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_67367e78-2ab4-499a-aeee-8fe7e604fc1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e89a5-68cf-7279-bfa8-0beb4fb003bc.webp",
      "image_media": {
        "alt_text": "Modern kitchen with a large island and bar stools.",
        "public_id": "019e89a5-68cf-7279-bfa8-0beb4fb003bc",
        "storage_key": "property/5191322281443328/019e89a5-68cf-7279-bfa8-0beb4fb003bc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Expansive kitchen featuring custom cabinetry, stainless steel appliances, and a granite-topped island with bar seating.",
      "link": "",
      "alt_text": "Modern kitchen with a large island and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c9ba5617-b4f3-4a31-883d-aeece3b509cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e89a5-6857-7368-8e7b-ce3a9b7945da.webp",
      "image_media": {
        "alt_text": "Gym with Matrix weight machines and treadmills.",
        "public_id": "019e89a5-6857-7368-8e7b-ce3a9b7945da",
        "storage_key": "property/5191322281443328/019e89a5-6857-7368-8e7b-ce3a9b7945da.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a wide selection of Matrix weight machines and cardio equipment, including treadmills and ellipticals.",
      "link": "",
      "alt_text": "Gym with Matrix weight machines and treadmills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_017fd752-0cb4-4fa3-9dc8-5a2e05c3c3fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e89a5-5cd8-70e0-aae2-331c4bf8a20c.webp",
      "image_media": {
        "alt_text": "Modern lounge area with plush seating and decorative elements, offering a welcoming atmosphere.",
        "public_id": "019e89a5-5cd8-70e0-aae2-331c4bf8a20c",
        "storage_key": "property/5191322281443328/019e89a5-5cd8-70e0-aae2-331c4bf8a20c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience sophisticated comfort in our resident lounge, featuring stylish seating and a contemporary design perfect for relaxation and socializing.",
      "link": "",
      "alt_text": "Modern lounge area with plush seating and decorative elements, offering a welcoming atmosphere.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d3b58de8-d3c7-45c1-b719-e1764cf1a959",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e89a5-5730-77cf-b168-d574bc83a789.webp",
      "image_media": {
        "alt_text": "Secure package lockers in a modern apartment building hallway.",
        "public_id": "019e89a5-5730-77cf-b168-d574bc83a789",
        "storage_key": "property/5191322281443328/019e89a5-5730-77cf-b168-d574bc83a789.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient and secure package lockers are available for residents, ensuring your deliveries are always safe and accessible.",
      "link": "",
      "alt_text": "Secure package lockers in a modern apartment building hallway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7683738d-2d5f-4858-9d0c-dfab890db7fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e89a5-529d-72dd-9fa5-305115f01e24.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019e89a5-529d-72dd-9fa5-305115f01e24",
        "storage_key": "property/5191322281443328/019e89a5-529d-72dd-9fa5-305115f01e24.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring sleek cabinetry, stainless steel appliances, and granite countertops. Includes an in-unit washer and dryer.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_870a912c-8324-4ea2-a5cc-f9142a675fe4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e89a5-558d-745c-917b-69853a10f26c.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019e89a5-558d-745c-917b-69853a10f26c",
        "storage_key": "property/5191322281443328/019e89a5-558d-745c-917b-69853a10f26c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a stylish bathroom featuring a granite-top vanity, a modern toilet, and a clean bathtub with a shower curtain. A perfect blend of form and function.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b887fcfb-5cfd-47b8-a5d6-855ffd02539e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e89a5-45fe-709c-8b5b-b38f1122f32d.webp",
      "image_media": {
        "alt_text": "Interior of a modern apartment living and dining area with a granite countertop bar.",
        "public_id": "019e89a5-45fe-709c-8b5b-b38f1122f32d",
        "storage_key": "property/5191322281443328/019e89a5-45fe-709c-8b5b-b38f1122f32d.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Step into this stylish apartment, featuring an open-concept living and dining area. Enjoy the convenience of a granite countertop bar and a beautifully furnished space perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Interior of a modern apartment living and dining area with a granite countertop bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7407467b-48dc-410e-85c5-a01192ab7176",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e89a5-40df-76e8-a339-b649257ffc1c.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, white bedding, and decorative pillows.",
        "public_id": "019e89a5-40df-76e8-a339-b649257ffc1c",
        "storage_key": "property/5191322281443328/019e89a5-40df-76e8-a339-b649257ffc1c.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, elegant decor, and ample natural light.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, white bedding, and decorative pillows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c5a66188-fdcc-4da3-8d04-bf21cba1664f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e89a5-4286-73cd-9534-ea8ceafb19ce.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a soaking tub, separate glass-enclosed shower, and double vanity with granite countertops.",
        "public_id": "019e89a5-4286-73cd-9534-ea8ceafb19ce",
        "storage_key": "property/5191322281443328/019e89a5-4286-73cd-9534-ea8ceafb19ce.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience luxury in our spacious bathrooms, featuring a deep soaking tub, a separate glass-enclosed shower, and a double vanity with elegant granite countertops.",
      "link": "",
      "alt_text": "Modern bathroom with a soaking tub, separate glass-enclosed shower, and double vanity with granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_4c0ba2f571b5fb5effdfdaa0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Lomontes Italian Restaurant and Bar",
      "poi_type": "Restaurants",
      "poi_address": "14510 Grisby Rd, Houston, TX 77079, USA",
      "poi_short_description": "Local institution offering a full Italian menu in a genteel setting with live music on weekends.",
      "poi_long_description": "Local institution offering a full Italian menu in a genteel setting with live music on weekends.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-232a-75e2-8f6a-c94aa2f506d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-232a-75e2-8f6a-c94aa2f506d2",
        "storage_key": "property/5191322281443328/019f1503-232a-75e2-8f6a-c94aa2f506d2.webp",
        "width": 1280,
        "height": 804
      },
      "poi_business_url": "https://www.lomontes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=333514742400317511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lomontes-italian-restaurant-and-bar",
      "poi_latitude": "29.7828007",
      "poi_longitude": "-95.6423868",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-496-0030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2aa4-7286-9c83-044adc4e00f2",
        "storage_key": "property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3y7j7eDbQIYRR3ggJOThoAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_ec67a089a57eea653cb27e5d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Lupe Tortilla",
      "poi_type": "Restaurants",
      "poi_address": "318 Stafford St, Houston, TX 77079, USA",
      "poi_short_description": "Regional Tex-Mex chain known for its homemade tortillas & variety of margaritas.",
      "poi_long_description": "Regional Tex-Mex chain known for its homemade tortillas & variety of margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-1be8-766b-baf2-a3445cf7b7b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-1be8-766b-baf2-a3445cf7b7b4",
        "storage_key": "property/5191322281443328/019f1503-1be8-766b-baf2-a3445cf7b7b4.webp",
        "width": 1280,
        "height": 815
      },
      "poi_business_url": "https://originallupetortilla.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17979223438454417878&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lupe-tortilla",
      "poi_latitude": "29.7828074",
      "poi_longitude": "-95.6430762",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-496-7580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2aa4-7286-9c83-044adc4e00f2",
        "storage_key": "property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QM1D1DKQIYR1ulzknUIg_k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "ec_f51f814dd0482ebb272253af",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Watson's House of Ales",
      "poi_type": "Restaurants",
      "poi_address": "14656 Grisby Rd, Houston, TX 77079, USA",
      "poi_short_description": "Classic neighborhood English pub with big menu of bar eats, tavern games & tree-covered patio.",
      "poi_long_description": "Classic neighborhood English pub with big menu of bar eats, tavern games & tree-covered patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-20d3-754d-bb3b-79d94ce8860d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-20d3-754d-bb3b-79d94ce8860d",
        "storage_key": "property/5191322281443328/019f1503-20d3-754d-bb3b-79d94ce8860d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.watsonshouseofales.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=40404887305559234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "watsons-house-of-ales",
      "poi_latitude": "29.7827699",
      "poi_longitude": "-95.6434556",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-920-2929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a97f-77f1-a354-31bb923e9ac9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a97f-77f1-a354-31bb923e9ac9",
        "storage_key": "property/5191322281443328/019f1503-a97f-77f1-a354-31bb923e9ac9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS2m-W-DbQIYRwpwJ6weMjwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "ec_d6edf7e1f8ddd8159cb610ce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Blue Agave Cantina",
      "poi_type": "Restaurants",
      "poi_address": "14555 Grisby Rd, Houston, TX 77079, USA",
      "poi_short_description": "Large, festive restaurant with a tree-covered patio serving creative & traditional Mexican cuisine.",
      "poi_long_description": "Large, festive restaurant with a tree-covered patio serving creative & traditional Mexican cuisine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-1ce1-77bc-8fc8-466d34bb1d96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-1ce1-77bc-8fc8-466d34bb1d96",
        "storage_key": "property/5191322281443328/019f1503-1ce1-77bc-8fc8-466d34bb1d96.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://blueagavehouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10660062755122231889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-agave-cantina",
      "poi_latitude": "29.7822849",
      "poi_longitude": "-95.6425995",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-602-3490",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2aa4-7286-9c83-044adc4e00f2",
        "storage_key": "property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93cBWxnbQIYRUbpuqpgm8JM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_af41838d6a1d6bd5baa7f295",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Ginger Thai Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "303 Grasshopper Ln, Houston, TX 77079, USA",
      "poi_short_description": "Informal spot producing Thai & sushi favorites in a colorful, contemporary setting.",
      "poi_long_description": "Informal spot producing Thai & sushi favorites in a colorful, contemporary setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-2337-727f-af9c-6f7c84879298.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-2337-727f-af9c-6f7c84879298",
        "storage_key": "property/5191322281443328/019f1503-2337-727f-af9c-6f7c84879298.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gingerthaitx.com/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=9124241330070850469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ginger-thai-cuisine",
      "poi_latitude": "29.7831853",
      "poi_longitude": "-95.6435358",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-531-7739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2aa4-7286-9c83-044adc4e00f2",
        "storage_key": "property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPxG9DbTbQIYRpYvPuyXRn34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "ec_8d00f86e248f19a560e102f0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Fajita Pete's - Energy Corridor",
      "poi_type": "Restaurants",
      "poi_address": "14627 Memorial Dr Ste A, Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-1ee6-76a9-a811-1a4ddd08ae20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-1ee6-76a9-a811-1a4ddd08ae20",
        "storage_key": "property/5191322281443328/019f1503-1ee6-76a9-a811-1a4ddd08ae20.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fajitasdelivered.com/stores/energy-corridor/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6137883322258243469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fajita-petes---energy-corridor",
      "poi_latitude": "29.7692761",
      "poi_longitude": "-95.6074615",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 346-229-4671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2aa4-7286-9c83-044adc4e00f2",
        "storage_key": "property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiVgwCTvbQIYRjT__l1wkLlU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_df469146f7688efa13c8a6ae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Cafe Benedicte",
      "poi_type": "Restaurants",
      "poi_address": "15455 Memorial Dr Ste 100, Houston, TX 77079, USA",
      "poi_short_description": "Quaint cafe with a menu spanning a variety of Mediterranean fares, wine flights & a low-key patio.",
      "poi_long_description": "Quaint cafe with a menu spanning a variety of Mediterranean fares, wine flights & a low-key patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-2648-7021-af37-c09020710488.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-2648-7021-af37-c09020710488",
        "storage_key": "property/5191322281443328/019f1503-2648-7021-af37-c09020710488.webp",
        "width": 1280,
        "height": 809
      },
      "poi_business_url": "https://cafebenedicte.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=10379844946288493440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cafe-benedicte",
      "poi_latitude": "29.7793888",
      "poi_longitude": "-95.6280094",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-741-0853",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2aa4-7286-9c83-044adc4e00f2",
        "storage_key": "property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUzQXievbQIYRgMMo3_udDJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "ec_f5c7a912b3a8f29973362d26",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Hungry's",
      "poi_type": "Restaurants",
      "poi_address": "14714 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "Sandwiches, simple entrees & brunch fare served in this casual establishment with a bar & patio.",
      "poi_long_description": "Sandwiches, simple entrees & brunch fare served in this casual establishment with a bar & patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-2070-72bc-ba99-1b63e332b508.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-2070-72bc-ba99-1b63e332b508",
        "storage_key": "property/5191322281443328/019f1503-2070-72bc-ba99-1b63e332b508.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://hungryscafe.com/locations/memorial-drive/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2299137294396829193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hungrys",
      "poi_latitude": "29.7706301",
      "poi_longitude": "-95.6091163",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-493-1520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2aa4-7286-9c83-044adc4e00f2",
        "storage_key": "property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSsgjGTbQIYRCS5gGjAt6B8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_dce532733e5b969b94b54be6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Nirvana Indian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "14543 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "Destination for Indian buffet at lunch & table service at dinner, plus a no-corkage-fee BYOB policy.",
      "poi_long_description": "Destination for Indian buffet at lunch & table service at dinner, plus a no-corkage-fee BYOB policy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-296e-7355-9489-7ab8e16afcf1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-296e-7355-9489-7ab8e16afcf1",
        "storage_key": "property/5191322281443328/019f1503-296e-7355-9489-7ab8e16afcf1.webp",
        "width": 1280,
        "height": 843
      },
      "poi_business_url": "https://www.nirvanahouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18117586541047354037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nirvana-indian-restaurant",
      "poi_latitude": "29.7696829",
      "poi_longitude": "-95.6047727",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-496-3232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2aa4-7286-9c83-044adc4e00f2",
        "storage_key": "property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4ykiF4LbQIYRtZKGzveYbvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "ec_9a18d6d8610061c49783f4ce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Sushi Jin",
      "poi_type": "Restaurants",
      "poi_address": "14670 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "Casual Japanese fixture known for fresh sushi offers sushi bar, booths & tatami mat seating.",
      "poi_long_description": "Casual Japanese fixture known for fresh sushi offers sushi bar, booths & tatami mat seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-1e2f-768d-b285-6b578563f16a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-1e2f-768d-b285-6b578563f16a",
        "storage_key": "property/5191322281443328/019f1503-1e2f-768d-b285-6b578563f16a.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://www.sushijin.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15264719107395545124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushi-jin",
      "poi_latitude": "29.7716907",
      "poi_longitude": "-95.6083483",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-493-2932",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2aa4-7286-9c83-044adc4e00f2",
        "storage_key": "property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkVW27IPbQIYRJOht-CYt19M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_763c7da7cbc44d570c6655c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "La Hacienda",
      "poi_type": "Restaurants",
      "poi_address": "14759 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "Colorful, family-friendly eatery offering Mexican fare including fajitas, tacos & margaritas.",
      "poi_long_description": "Colorful, family-friendly eatery offering Mexican fare including fajitas, tacos & margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-2a3b-704a-aee5-79cea53dbb9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-2a3b-704a-aee5-79cea53dbb9a",
        "storage_key": "property/5191322281443328/019f1503-2a3b-704a-aee5-79cea53dbb9a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://la-hacienda-tx.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17796729739918849864&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-hacienda",
      "poi_latitude": "29.7704769",
      "poi_longitude": "-95.6114294",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-493-2252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2aa4-7286-9c83-044adc4e00f2",
        "storage_key": "property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKVRMUITbQIYRSDd-R2iv-vY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_a2d9419f59bbb68a640effb5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Kolache Factory",
      "poi_type": "Restaurants",
      "poi_address": "14129 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "Counter-serve chain with classic Czech pastries in sweet & savory flavors, plus other baked goods.",
      "poi_long_description": "Counter-serve chain with classic Czech pastries in sweet & savory flavors, plus other baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-2771-737a-93c9-4cf1e17fd5c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-2771-737a-93c9-4cf1e17fd5c1",
        "storage_key": "property/5191322281443328/019f1503-2771-737a-93c9-4cf1e17fd5c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.kolachefactory.com/tx/houston/14129-memorial-drive",
      "poi_directions_map_url": "https://maps.google.com/?cid=396530948099579657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kolache-factory",
      "poi_latitude": "29.7697612",
      "poi_longitude": "-95.592684",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-759-2253",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2aa4-7286-9c83-044adc4e00f2",
        "storage_key": "property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCypEqGTbQIYRCZ_s38vCgAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_0db8eb0cb53e263daaa4a54a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "DaddyO's Pizza - Memorial",
      "poi_type": "Restaurants",
      "poi_address": "861 Dairy Ashford Rd, Houston, TX 77079, USA",
      "poi_short_description": "Casual, clean-looking spot serving specialty pies with crispy, hand-tossed dough, alongside pasta and subs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-27e9-776f-ae66-5ad2eb6d566d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-27e9-776f-ae66-5ad2eb6d566d",
        "storage_key": "property/5191322281443328/019f1503-27e9-776f-ae66-5ad2eb6d566d.webp",
        "width": 1280,
        "height": 778
      },
      "poi_business_url": "https://www.daddyospizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8995948136722137959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daddyos-pizza---memorial",
      "poi_latitude": "29.7757593",
      "poi_longitude": "-95.6067079",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 832-844-0444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2aa4-7286-9c83-044adc4e00f2",
        "storage_key": "property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD9Fy2JzbQIYRZwMp8yoH2Hw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_d0db98401efc6a403c8fd4bf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Perry's Steakhouse & Grille",
      "poi_type": "Restaurants",
      "poi_address": "9827 Katy Fwy, Houston, TX 77024, USA",
      "poi_short_description": "Upscale steakhouse & grill serving a menu including chops, seafood, wine & cocktails.",
      "poi_long_description": "Upscale steakhouse & grill serving a menu including chops, seafood, wine & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-2ef0-752e-90e4-d3d1bcad2cc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-2ef0-752e-90e4-d3d1bcad2cc8",
        "storage_key": "property/5191322281443328/019f1503-2ef0-752e-90e4-d3d1bcad2cc8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.perryssteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1676590696722850463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "perrys-steakhouse--grille",
      "poi_latitude": "29.7833333",
      "poi_longitude": "-95.5386111",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 832-358-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2aa4-7286-9c83-044adc4e00f2",
        "storage_key": "property/5191322281443328/019f1500-2aa4-7286-9c83-044adc4e00f2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo7Y_15XEQIYRn-LjD1tyRBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_616a7be46f05341ae90e74d4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "14344 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-2a4a-739b-893d-ea5b9d570e76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-2a4a-739b-893d-ea5b9d570e76",
        "storage_key": "property/5191322281443328/019f1503-2a4a-739b-893d-ea5b9d570e76.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/houston/country-place/034/00161?cid=loc_03400161_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12521005282354222743&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "29.7712017",
      "poi_longitude": "-95.5991046",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-493-1702",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9b-7207-b575-128f518999e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9b-7207-b575-128f518999e4",
        "storage_key": "property/5191322281443328/019f1500-2a9b-7207-b575-128f518999e4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu025bnnbQIYRl1aDFfeLw60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_11e75c0cda42ec286a83b1c4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Randalls",
      "poi_type": "Shopping & Retail",
      "poi_address": "14610 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "Chain grocery for produce and bakery goods, plus prepared foods and a pharmacy.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-2e34-713a-a9b4-ed84a33afda2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-2e34-713a-a9b4-ed84a33afda2",
        "storage_key": "property/5191322281443328/019f1503-2e34-713a-a9b4-ed84a33afda2.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://local.randalls.com/tx/houston/14610-memorial-dr.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=18242023513135570209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "randalls",
      "poi_latitude": "29.7717909",
      "poi_longitude": "-95.6072036",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-497-0630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9b-7207-b575-128f518999e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9b-7207-b575-128f518999e4",
        "storage_key": "property/5191322281443328/019f1500-2a9b-7207-b575-128f518999e4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF_dcx4PbQIYRId3EHLyvKP0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_52f8ce8e2dc94a1a1f0efd7b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "14616 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-3717-768b-9c05-47b2e2086c90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-3717-768b-9c05-47b2e2086c90",
        "storage_key": "property/5191322281443328/019f1503-3717-768b-9c05-47b2e2086c90.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-14616+memorial+dr-houston-tx-77079/id=5094",
      "poi_directions_map_url": "https://maps.google.com/?cid=9305211007065525541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.7705497",
      "poi_longitude": "-95.6084642",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-493-3043",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9f-76db-9d86-a9f8c05ad427",
        "storage_key": "property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcVeswIPbQIYRJQ0yHBzAIoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_0d5715d3644293f816b5c323",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "15010 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-2ee8-765f-8d43-2859ee64d2a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-2ee8-765f-8d43-2859ee64d2a2",
        "storage_key": "property/5191322281443328/019f1503-2ee8-765f-8d43-2859ee64d2a2.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/houston-tx-pharmacies/15010-memorial-dr-houston-tx-77079/storeid=1753?WT.mc_id=LS_GOOGLE_RX_1753",
      "poi_directions_map_url": "https://maps.google.com/?cid=4278914173596286417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.7788153",
      "poi_longitude": "-95.6190054",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-368-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a996-7675-a52a-83b25e78ef58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a996-7675-a52a-83b25e78ef58",
        "storage_key": "property/5191322281443328/019f1503-a996-7675-a52a-83b25e78ef58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ90jARJHbQIYR0T2XLcXBYTs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_020f4618f9fe072cb252a114",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "OHC Medical Supply",
      "poi_type": "Shopping & Retail",
      "poi_address": "14520 Memorial Dr Ste 22, Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-32cd-77cc-8d2b-522ebd96fe61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-32cd-77cc-8d2b-522ebd96fe61",
        "storage_key": "property/5191322281443328/019f1503-32cd-77cc-8d2b-522ebd96fe61.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ohcmedicalsupply.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9226914700454203909&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ohc-medical-supply",
      "poi_latitude": "29.7708934",
      "poi_longitude": "-95.6039145",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-674-4440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a98-7520-8cb2-b1509a582cfb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a98-7520-8cb2-b1509a582cfb",
        "storage_key": "property/5191322281443328/019f1500-2a98-7520-8cb2-b1509a582cfb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6QOEgbbbQIYRBRJnpQiWDIA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_7e29892d198356740d4b8173",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Memorial City Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "303 Memorial City Way, Houston, TX 77024, USA",
      "poi_short_description": "Large complex with familiar retail shops, dining, movies, a carousel, play area & ice-skating rink.",
      "poi_long_description": "Large complex with familiar retail shops, dining, movies, a carousel, play area & ice-skating rink.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-3071-7269-a185-53a37a77582c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-3071-7269-a185-53a37a77582c",
        "storage_key": "property/5191322281443328/019f1503-3071-7269-a185-53a37a77582c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.memorialcity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11072518101315744963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-city-mall",
      "poi_latitude": "29.7807002",
      "poi_longitude": "-95.5379007",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 713-464-8640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a98-7520-8cb2-b1509a582cfb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a98-7520-8cb2-b1509a582cfb",
        "storage_key": "property/5191322281443328/019f1500-2a98-7520-8cb2-b1509a582cfb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIXBsJZbEQIYRw_QBZox8qZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_3558fbc181e7da42c4db57fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Town & Country Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "12850 Memorial Dr, Houston, TX 77024, USA",
      "poi_short_description": "Upscale shopping plaza featuring clothing, furniture, electronics & craft stores, plus eateries.",
      "poi_long_description": "Upscale shopping plaza featuring clothing, furniture, electronics & craft stores, plus eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-3393-7500-8d5f-0afe19153fee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-3393-7500-8d5f-0afe19153fee",
        "storage_key": "property/5191322281443328/019f1503-3393-7500-8d5f-0afe19153fee.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.townandcountryvillage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14313415948417426199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town--country-village",
      "poi_latitude": "29.7753305",
      "poi_longitude": "-95.5602272",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 713-464-7353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a98-7520-8cb2-b1509a582cfb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a98-7520-8cb2-b1509a582cfb",
        "storage_key": "property/5191322281443328/019f1500-2a98-7520-8cb2-b1509a582cfb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn_RK26zEQIYRF-PUJ_h3o8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_fce0cd4f370e5ad3e5d06472",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Bear Creek",
      "poi_type": "Shopping & Retail",
      "poi_address": "4845 Hwy 6 N, Houston, TX 77084, USA",
      "poi_short_description": "Grocery store part of West Point Plaza with a big produce department, plus a pharmacy.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-327f-734a-a19c-f213bc44153b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-327f-734a-a19c-f213bc44153b",
        "storage_key": "property/5191322281443328/019f1503-327f-734a-a19c-f213bc44153b.webp",
        "width": 1280,
        "height": 1006
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8339718003161929455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-creek",
      "poi_latitude": "29.84732619999999",
      "poi_longitude": "-95.6473541",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 713-357-2180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9b-7207-b575-128f518999e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9b-7207-b575-128f518999e4",
        "storage_key": "property/5191322281443328/019f1500-2a9b-7207-b575-128f518999e4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR2IdWP_ZQIYR75ZlkVahvHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_085592337945bd51dbd13b74",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "7810 Katy Fwy, Houston, TX 77024, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-3337-776d-8841-0c2a6942fe58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-3337-776d-8841-0c2a6942fe58",
        "storage_key": "property/5191322281443328/019f1503-3337-776d-8841-0c2a6942fe58.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/houston/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=houston",
      "poi_directions_map_url": "https://maps.google.com/?cid=15497895523337716893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "29.7854269",
      "poi_longitude": "-95.4722835",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "4 hours 0 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a98-7520-8cb2-b1509a582cfb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a98-7520-8cb2-b1509a582cfb",
        "storage_key": "property/5191322281443328/019f1500-2a98-7520-8cb2-b1509a582cfb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnbXIkR3EQIYRnUSp-t2VE9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "ec_ec27f1634b9ba2ddd69f20a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Maurice L. Wolfe Elementary",
      "poi_type": "Education",
      "poi_address": "502 Addicks-Howell Rd, Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-377a-740a-94f5-0c372d9b3a02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-377a-740a-94f5-0c372d9b3a02",
        "storage_key": "property/5191322281443328/019f1503-377a-740a-94f5-0c372d9b3a02.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.katyisd.org/WE",
      "poi_directions_map_url": "https://maps.google.com/?cid=9545534090863295334&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maurice-l-wolfe-elementary",
      "poi_latitude": "29.78026059999999",
      "poi_longitude": "-95.6434258",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-237-2250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac1-731a-af2c-6d7caf4d3b9a",
        "storage_key": "property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3VkfGOHbQIYRZrtJZa6MeIQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_c9bf581a2693dc4fe50c0c71",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Memorial Parkway Junior High School",
      "poi_type": "Education",
      "poi_address": "Q757+4V, 21203 Highland Knolls Dr, Katy, TX 77450, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-37d1-700c-9ed6-230a2772a580.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-37d1-700c-9ed6-230a2772a580",
        "storage_key": "property/5191322281443328/019f1503-37d1-700c-9ed6-230a2772a580.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.katyisd.org/MPJH",
      "poi_directions_map_url": "https://maps.google.com/?cid=2727377037625107558&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-parkway-junior-high-school",
      "poi_latitude": "29.7581433",
      "poi_longitude": "-95.7356535",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 281-237-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac1-731a-af2c-6d7caf4d3b9a",
        "storage_key": "property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw7epQTUnQYYRZqQzKPeW2SU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_7302e7e1c75403fc67d455f8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "James E. Taylor High School",
      "poi_type": "Education",
      "poi_address": "20700 Kingsland Blvd, Katy, TX 77450, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-3dc1-7795-b9a3-b27da0d120a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-3dc1-7795-b9a3-b27da0d120a2",
        "storage_key": "property/5191322281443328/019f1503-3dc1-7795-b9a3-b27da0d120a2.webp",
        "width": 622,
        "height": 1280
      },
      "poi_business_url": "https://www.katyisd.org/THS",
      "poi_directions_map_url": "https://maps.google.com/?cid=14600269183051327030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-e-taylor-high-school",
      "poi_latitude": "29.7765191",
      "poi_longitude": "-95.7312123",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-237-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac1-731a-af2c-6d7caf4d3b9a",
        "storage_key": "property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAVJBhF8nQYYRNmbbaHeTnso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_fd69c5ba3c8f5bc95dbcf04b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Smaller Scholars Montessori Academy",
      "poi_type": "Education",
      "poi_address": "14455 Grisby Rd, Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-3a96-7090-bffa-819bc3ab8519.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-3a96-7090-bffa-819bc3ab8519",
        "storage_key": "property/5191322281443328/019f1503-3a96-7090-bffa-819bc3ab8519.webp",
        "width": 920,
        "height": 690
      },
      "poi_business_url": "https://www.cadence-education.com/locations/tx/houston/382?utm_source=google&utm_medium=local_listing&utm_campaign=local_seo",
      "poi_directions_map_url": "https://maps.google.com/?cid=13860138164144705995&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smaller-scholars-montessori-academy",
      "poi_latitude": "29.7822081",
      "poi_longitude": "-95.6412363",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-954-9937",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac1-731a-af2c-6d7caf4d3b9a",
        "storage_key": "property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIzYH2-DbQIYRyxGu4zkaWcA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_265d0e3eb5dbac6525365baf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "The Alphabet Club",
      "poi_type": "Education",
      "poi_address": "14530 Old Katy Rd, Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-3db5-75be-841b-43bb0b4e1f0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-3db5-75be-841b-43bb0b4e1f0a",
        "storage_key": "property/5191322281443328/019f1503-3db5-75be-841b-43bb0b4e1f0a.webp",
        "width": 1125,
        "height": 1139
      },
      "poi_business_url": "http://www.alphabetclubcdc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15303708293630532482&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-alphabet-club",
      "poi_latitude": "29.7857232",
      "poi_longitude": "-95.6438921",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-801-9481",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac1-731a-af2c-6d7caf4d3b9a",
        "storage_key": "property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhYBwyt_bQIYRghsMTJyxYdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_40951011f3141d9b39bf54dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Primrose School of Eldridge Parkway",
      "poi_type": "Education",
      "poi_address": "2150 Eldridge Pkwy, Houston, TX 77077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-4212-716c-8103-d102892b59cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-4212-716c-8103-d102892b59cc",
        "storage_key": "property/5191322281443328/019f1503-4212-716c-8103-d102892b59cc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.primroseschools.com/schools/eldridge-parkway/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=9754915494377581714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-eldridge-parkway",
      "poi_latitude": "29.74364",
      "poi_longitude": "-95.624892",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-589-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac1-731a-af2c-6d7caf4d3b9a",
        "storage_key": "property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw3gCS2vcQIYRkmxUWPVrYIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_4411bf56d044fe185c503605",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "The Goddard School of Houston - Energy Corridor",
      "poi_type": "Education",
      "poi_address": "1720 Cres Plz Dr, Houston, TX 77077, USA",
      "poi_short_description": "Private school for infants - through kindergarten, with friendly staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-46ba-71b0-9cd6-7ea407239456.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-46ba-71b0-9cd6-7ea407239456",
        "storage_key": "property/5191322281443328/019f1503-46ba-71b0-9cd6-7ea407239456.webp",
        "width": 640,
        "height": 427
      },
      "poi_business_url": "https://www.goddardschool.com/schools/tx/houston/houston-energy-corridor?utm_source=google&utm_medium=business_listings&utm_campaign=school&utm_content=main_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=8189071439442376969&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-goddard-school-of-houston---energy-corridor",
      "poi_latitude": "29.752005",
      "poi_longitude": "-95.62424",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-596-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac1-731a-af2c-6d7caf4d3b9a",
        "storage_key": "property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ67JwvXLcQIYRCXlCLBZtpXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_cdb763a02956d5083d3daa24",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Lycée International de Houston - LIH",
      "poi_type": "Education",
      "poi_address": "15950 Park Row Blvd Ste.A, Houston, TX 77084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-4cf2-7199-ab33-7a1ee1c76434.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-4cf2-7199-ab33-7a1ee1c76434",
        "storage_key": "property/5191322281443328/019f1503-4cf2-7199-ab33-7a1ee1c76434.webp",
        "width": 1280,
        "height": 612
      },
      "poi_business_url": "https://www.lihouston.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3481477405101064279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lyce-international-de-houston---lih",
      "poi_latitude": "29.7890692",
      "poi_longitude": "-95.6618742",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 832-474-1013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac1-731a-af2c-6d7caf4d3b9a",
        "storage_key": "property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn4iXq27ZQIYRVwCZGEGxUDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_28d801dde57a4708f8ceebda",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "The Village School, High School (Main Campus)",
      "poi_type": "Education",
      "poi_address": "13051 Whittington Dr, Houston, TX 77077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-5206-710c-a401-9131722581e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-5206-710c-a401-9131722581e1",
        "storage_key": "property/5191322281443328/019f1503-5206-710c-a401-9131722581e1.webp",
        "width": 1280,
        "height": 415
      },
      "poi_business_url": "https://www.nordangliaeducation.com/village-houston?utm_source=google&utm_medium=organic&utm_campaign=Yext_GBM_AM019_16241121&y_source=1_MTYyNDExMjEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10590733025902132245&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-village-school-high-school-main-campus",
      "poi_latitude": "29.7462154",
      "poi_longitude": "-95.6193682",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-496-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac1-731a-af2c-6d7caf4d3b9a",
        "storage_key": "property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6zpowW7cQIYRFfzkL5PX-ZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_fc62da397a1deafb67040fa8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Houston City College - West Loop Campus",
      "poi_type": "Education",
      "poi_address": "5601 W Loop S, Houston, TX 77081, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-42c4-7630-bdc9-ca3dfc2f7c73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-42c4-7630-bdc9-ca3dfc2f7c73",
        "storage_key": "property/5191322281443328/019f1503-42c4-7630-bdc9-ca3dfc2f7c73.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://www.hccs.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6584179847211332118&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-city-college---west-loop-campus",
      "poi_latitude": "29.7214212",
      "poi_longitude": "-95.4581271",
      "poi_miles_from_property": "15.3 mi",
      "poi_walking_minutes": "5 hours 43 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 713-718-7868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac1-731a-af2c-6d7caf4d3b9a",
        "storage_key": "property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ28ALNp7BQIYRFjJRwq-0X1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_2b9fa6b4fa2eac28e11f6b36",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Star Cinema Grill CityCentre",
      "poi_type": "Entertainment",
      "poi_address": "CityCenter, 822 Town and Country Blvd Ste 200, Houston, TX 77024, USA",
      "poi_short_description": "Theatre featuring seat-side service, reclining chairs, heated seats and an expanded menu.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-4e7a-758c-b8e5-143446c98d1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-4e7a-758c-b8e5-143446c98d1e",
        "storage_key": "property/5191322281443328/019f1503-4e7a-758c-b8e5-143446c98d1e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.starcinemagrill.net/movie-theater/citycentre",
      "poi_directions_map_url": "https://maps.google.com/?cid=5867569438081115187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "star-cinema-grill-citycentre",
      "poi_latitude": "29.7816296",
      "poi_longitude": "-95.5610211",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 713-277-7910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a996-7675-a52a-866fd59aa771.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a996-7675-a52a-866fd59aa771",
        "storage_key": "property/5191322281443328/019f1503-a996-7675-a52a-866fd59aa771.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJHdroU0PFQIYRM2TD81DLbVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_5f15783e87b413e74dc8d337",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Cinemark Memorial City",
      "poi_type": "Entertainment",
      "poi_address": "310 Memorial City Mall, Houston, TX 77024, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-49d2-7458-8d01-3142cf4a6d4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-49d2-7458-8d01-3142cf4a6d4d",
        "storage_key": "property/5191322281443328/019f1503-49d2-7458-8d01-3142cf4a6d4d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-houston/cinemark-memorial-city?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxNTktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13006184974408473747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-memorial-city",
      "poi_latitude": "29.7799092",
      "poi_longitude": "-95.5408135",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 713-467-9749",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a996-7675-a52a-866fd59aa771.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a996-7675-a52a-866fd59aa771",
        "storage_key": "property/5191322281443328/019f1503-a996-7675-a52a-866fd59aa771.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJSwXHNpfEQIYRk9yjElNAf7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_a0da886ad500766eb53a4301",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "CITYCENTRE",
      "poi_type": "Entertainment",
      "poi_address": "800 Town and Country Blvd, Houston, TX 77024, USA",
      "poi_short_description": "Contemporary shopping compound featuring brand-name stores, restaurants & live music in the plaza.",
      "poi_long_description": "Contemporary shopping compound featuring brand-name stores, restaurants & live music in the plaza.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f14ff-a3de-742e-ac0e-d88a9e212307.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-a3de-742e-ac0e-d88a9e212307",
        "storage_key": "property/5191322281443328/019f14ff-a3de-742e-ac0e-d88a9e212307.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.citycentrehouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16787131420789938490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "citycentre",
      "poi_latitude": "29.7810228",
      "poi_longitude": "-95.5592668",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 713-463-4692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a98-7520-8cb2-b1509a582cfb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a98-7520-8cb2-b1509a582cfb",
        "storage_key": "property/5191322281443328/019f1500-2a98-7520-8cb2-b1509a582cfb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTQ_xOrPEQIYROpn7zRXf9-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_66c9cd4016bb7291b8aab4a1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Monarch Bar and Lounge",
      "poi_type": "Entertainment",
      "poi_address": "14129 Memorial Dr Ste E, Houston, TX 77079, USA",
      "poi_short_description": "Open-concept bar and grill with a rooftop patio offers food, cocktails, and live music.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-55ac-767a-923c-b7e6c83fc9b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-55ac-767a-923c-b7e6c83fc9b8",
        "storage_key": "property/5191322281443328/019f1503-55ac-767a-923c-b7e6c83fc9b8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://4monarch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5200209727870009847&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "monarch-bar-and-lounge",
      "poi_latitude": "29.7694713",
      "poi_longitude": "-95.5927055",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-741-7618",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a97f-77f1-a354-31bb923e9ac9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a97f-77f1-a354-31bb923e9ac9",
        "storage_key": "property/5191322281443328/019f1503-a97f-77f1-a354-31bb923e9ac9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5et6-VfbQIYR9wE5EzLbKkg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_2d390c66669673cfe1edf0c6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Publik Reserve",
      "poi_type": "Entertainment",
      "poi_address": "12914 FM 1960, Houston, TX 77065, USA",
      "poi_short_description": "Casual bar featuring happy hour, live music, and karaoke, plus a patio and popcorn.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-53fe-74aa-a0e2-06bc460f1f3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-53fe-74aa-a0e2-06bc460f1f3a",
        "storage_key": "property/5191322281443328/019f1503-53fe-74aa-a0e2-06bc460f1f3a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publikreserve.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3496869781935255391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publik-reserve",
      "poi_latitude": "29.919722",
      "poi_longitude": "-95.6110221",
      "poi_miles_from_property": "11.1 mi",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 281-517-0782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a97f-77f1-a354-31bb923e9ac9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a97f-77f1-a354-31bb923e9ac9",
        "storage_key": "property/5191322281443328/019f1503-a97f-77f1-a354-31bb923e9ac9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz4Ra4anRQIYRX28MGopghzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_1c41487ca4b38e1631a1293e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Miller Outdoor Theatre",
      "poi_type": "Entertainment",
      "poi_address": "6000 Hermann Park Dr, Houston, TX 77030, USA",
      "poi_short_description": "Outdoor spot featuring an 8-month season of free live shows including dance, music & theater.",
      "poi_long_description": "Outdoor spot featuring an 8-month season of free live shows including dance, music & theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-501c-73b6-a429-e803bb49a04a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-501c-73b6-a429-e803bb49a04a",
        "storage_key": "property/5191322281443328/019f1503-501c-73b6-a429-e803bb49a04a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.milleroutdoortheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9187538833049148667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miller-outdoor-theatre",
      "poi_latitude": "29.7191812",
      "poi_longitude": "-95.3886681",
      "poi_miles_from_property": "19.0 mi",
      "poi_walking_minutes": "7 hours 6 mins",
      "poi_biking_minutes": "1 hour 52 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 832-487-7123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9f-76db-9d86-a9f8c05ad427",
        "storage_key": "property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-b_yEIa_QIYR-1wAGOSxgH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_211e9d25309a5bf72458628d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Houston Museum of Natural Science",
      "poi_type": "Entertainment",
      "poi_address": "5555 Hermann Park Dr, Houston, TX 77030, USA",
      "poi_short_description": "Museum with dinosaur hall & other permanent exhibits, planetarium, IMAX theater & butterfly house.",
      "poi_long_description": "Museum with dinosaur hall & other permanent exhibits, planetarium, IMAX theater & butterfly house.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-59da-7259-8092-28c79babe833.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-59da-7259-8092-28c79babe833",
        "storage_key": "property/5191322281443328/019f1503-59da-7259-8092-28c79babe833.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.hmns.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13538717968826751354&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-museum-of-natural-science",
      "poi_latitude": "29.7220625",
      "poi_longitude": "-95.3895625",
      "poi_miles_from_property": "19.0 mi",
      "poi_walking_minutes": "7 hours 7 mins",
      "poi_biking_minutes": "1 hour 50 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 713-639-4629",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a992-753e-bd3b-95ff0341f623.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a992-753e-bd3b-95ff0341f623",
        "storage_key": "property/5191322281443328/019f1503-a992-753e-bd3b-95ff0341f623.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJqzEuToa_QIYRetkd7kIw47s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_78aa5998ff46d6d3dcf7e8da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "The Museum of Fine Arts, Houston",
      "poi_type": "Entertainment",
      "poi_address": "1001 Bissonnet St, Houston, TX 77005, USA",
      "poi_short_description": "Distinct campus & sculpture garden with notable art from antiquity to today, plus films & programs.",
      "poi_long_description": "Distinct campus & sculpture garden with notable art from antiquity to today, plus films & programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-55a3-714a-b7e9-287caa137431.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-55a3-714a-b7e9-287caa137431",
        "storage_key": "property/5191322281443328/019f1503-55a3-714a-b7e9-287caa137431.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.mfah.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12856993702091728189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-museum-of-fine-arts-houston",
      "poi_latitude": "29.7256229",
      "poi_longitude": "-95.3905328",
      "poi_miles_from_property": "18.6 mi",
      "poi_walking_minutes": "6 hours 58 mins",
      "poi_biking_minutes": "1 hour 49 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 713-639-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a992-753e-bd3b-95ff0341f623.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a992-753e-bd3b-95ff0341f623",
        "storage_key": "property/5191322281443328/019f1503-a992-753e-bd3b-95ff0341f623.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJSx6QT3-_QIYRPaWcHKc3bbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_5176253a474ceac9aa71721b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Children's Museum Houston",
      "poi_type": "Entertainment",
      "poi_address": "1500 Binz St, Houston, TX 77004, USA",
      "poi_short_description": "Bustling family museum with a wealth of hands-on activities such as a Bubble Lab & a Tot Spot.",
      "poi_long_description": "Bustling family museum with a wealth of hands-on activities such as a Bubble Lab & a Tot Spot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-598d-7709-b97e-5ada1771883f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-598d-7709-b97e-5ada1771883f",
        "storage_key": "property/5191322281443328/019f1503-598d-7709-b97e-5ada1771883f.webp",
        "width": 1280,
        "height": 873
      },
      "poi_business_url": "https://www.cmhouston.org/?utm_source=google&utm_medium=organic&utm_campaign=gmbhouston",
      "poi_directions_map_url": "https://maps.google.com/?cid=11886735036379074938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-museum-houston",
      "poi_latitude": "29.7229313",
      "poi_longitude": "-95.385289",
      "poi_miles_from_property": "19.0 mi",
      "poi_walking_minutes": "7 hours 7 mins",
      "poi_biking_minutes": "1 hour 51 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 713-522-1138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a992-753e-bd3b-95ff0341f623.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a992-753e-bd3b-95ff0341f623",
        "storage_key": "property/5191322281443328/019f1503-a992-753e-bd3b-95ff0341f623.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJoXCzG4O_QIYRepGQdokq9qQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_a67bc9641ebdbf0dd49f7dee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Houston Zoo",
      "poi_type": "Entertainment",
      "poi_address": "6200 Hermann Park Dr, Houston, TX 77030, USA",
      "poi_short_description": "Visitors can see 6,000+ animals in natural, habitat-style exhibits & watch daily care & feedings.",
      "poi_long_description": "Visitors can see 6,000+ animals in natural, habitat-style exhibits & watch daily care & feedings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-58b9-7629-86d6-61f0388cbe2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-58b9-7629-86d6-61f0388cbe2a",
        "storage_key": "property/5191322281443328/019f1503-58b9-7629-86d6-61f0388cbe2a.webp",
        "width": 1080,
        "height": 719
      },
      "poi_business_url": "https://www.houstonzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7058276189404686840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-zoo",
      "poi_latitude": "29.7157813",
      "poi_longitude": "-95.3903207",
      "poi_miles_from_property": "19.1 mi",
      "poi_walking_minutes": "7 hours 8 mins",
      "poi_biking_minutes": "1 hour 53 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 713-533-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9f-76db-9d86-a9f8c05ad427",
        "storage_key": "property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEzJREIa_QIYR-GkQRMwI9GE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "ec_d20d7fd539e5559e2a87c0a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Houston Methodist West Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "18500 Katy Fwy, Houston, TX 77094, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f14ff-d587-72fa-91f4-47c1ef32f4f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-d587-72fa-91f4-47c1ef32f4f3",
        "storage_key": "property/5191322281443328/019f14ff-d587-72fa-91f4-47c1ef32f4f3.webp",
        "width": 1280,
        "height": 629
      },
      "poi_business_url": "https://www.houstonmethodist.org/locations/katy-west/?utm_source=gmb&utm_medium=organic&utm_campaign=all_location_gmb&utm_content=website-click",
      "poi_directions_map_url": "https://maps.google.com/?cid=9315019254502396471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-methodist-west-hospital",
      "poi_latitude": "29.7872016",
      "poi_longitude": "-95.6982542",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 832-522-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac1-731a-af2c-69e3064f7be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac1-731a-af2c-69e3064f7be0",
        "storage_key": "property/5191322281443328/019f1500-2ac1-731a-af2c-69e3064f7be0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJqYUrEObYQIYRNxKKrKiYRYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_85cb97d24aa096a7a8ee97c2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Memorial Village Emergency Room",
      "poi_type": "Health and Wellness",
      "poi_address": "14520 Memorial Dr #4, Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-5f69-776c-a0da-2a7f3ba71919.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-5f69-776c-a0da-2a7f3ba71919",
        "storage_key": "property/5191322281443328/019f1503-5f69-776c-a0da-2a7f3ba71919.webp",
        "width": 1280,
        "height": 1273
      },
      "poi_business_url": "https://memorialvillageer.com/?utm_source=GMB&utm_medium=Organic&utm_campaign=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=8782338043858047112&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-village-emergency-room",
      "poi_latitude": "29.7705503",
      "poi_longitude": "-95.6040345",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-496-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9f-76db-9d86-a9f8c05ad427",
        "storage_key": "property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7UUdh3jbQIYRiNCOiesh4Xk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_c1328d93a148c633b8e10e42",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Memorial Primary & Urgent Care Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "14629 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-5e9b-7408-bd24-b3cc8c4ae0ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-5e9b-7408-bd24-b3cc8c4ae0ef",
        "storage_key": "property/5191322281443328/019f1503-5e9b-7408-bd24-b3cc8c4ae0ef.webp",
        "width": 447,
        "height": 380
      },
      "poi_business_url": "https://www.urgentcarememorial.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14608600992296955280&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-primary--urgent-care-clinic",
      "poi_latitude": "29.7694071",
      "poi_longitude": "-95.6075827",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-503-8968",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9f-76db-9d86-a9f8c05ad427",
        "storage_key": "property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ9pD64PbQIYRkG1H6zMtvMo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_f77bd4eaf7096f361559bc9c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "15010 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-6a59-70ff-9c6f-60408356be72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-6a59-70ff-9c6f-60408356be72",
        "storage_key": "property/5191322281443328/019f1503-6a59-70ff-9c6f-60408356be72.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/houston-tx-pharmacies/15010-memorial-dr-houston-tx-77079/storeid=1753?WT.mc_id=LS_GOOGLE_FS_1753",
      "poi_directions_map_url": "https://maps.google.com/?cid=13966581577759382091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "29.7787771",
      "poi_longitude": "-95.6187735",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-368-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9f-76db-9d86-a9f8c05ad427",
        "storage_key": "property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe2EtS3zbQIYRS9rcZPJD08E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_a4c829c3f757c500c86a856e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Memorial Athletic Club and Aquatic Center",
      "poi_type": "Health and Wellness",
      "poi_address": "14690 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "Cardio, strength-training and swimming-focused center offering yoga sessions, fitness classes and lap pools.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f14ff-d183-76ac-8dc9-0cafe574b6ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-d183-76ac-8dc9-0cafe574b6ed",
        "storage_key": "property/5191322281443328/019f14ff-d183-76ac-8dc9-0cafe574b6ed.webp",
        "width": 1280,
        "height": 702
      },
      "poi_business_url": "http://www.fitmac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16261631170102517880&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-athletic-club-and-aquatic-center",
      "poi_latitude": "29.77217899999999",
      "poi_longitude": "-95.608032",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-497-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9f-76db-9d86-a9f8c05ad427",
        "storage_key": "property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb-l6cIPbQIYReGBhMmTrrOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_60999204525be55b4075d186",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "14616 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-3717-768b-9c05-47b2e2086c90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-3717-768b-9c05-47b2e2086c90",
        "storage_key": "property/5191322281443328/019f1503-3717-768b-9c05-47b2e2086c90.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-14616+memorial+dr-houston-tx-77079/id=5094",
      "poi_directions_map_url": "https://maps.google.com/?cid=9305211007065525541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.7705497",
      "poi_longitude": "-95.6084642",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-493-3043",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9f-76db-9d86-a9f8c05ad427",
        "storage_key": "property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcVeswIPbQIYRJQ0yHBzAIoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_2102c43ece8cbdb8eed8d120",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Randalls Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "14610 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-671a-7269-8d79-d08da5562757.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-671a-7269-8d79-d08da5562757",
        "storage_key": "property/5191322281443328/019f1503-671a-7269-8d79-d08da5562757.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://local.pharmacy.randalls.com/tx/houston/14610-memorial-dr.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=6374543074012282717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "randalls-pharmacy",
      "poi_latitude": "29.7718511",
      "poi_longitude": "-95.6072215",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-589-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a996-7675-a52a-83b25e78ef58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a996-7675-a52a-83b25e78ef58",
        "storage_key": "property/5191322281443328/019f1503-a996-7675-a52a-83b25e78ef58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF_dcx4PbQIYRXb_t6ybtdlg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_973d9e1c147c7367251d4540",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Kroger Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "14344 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-6665-702d-87f6-6608a8a6d182.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-6665-702d-87f6-6608a8a6d182",
        "storage_key": "property/5191322281443328/019f1503-6665-702d-87f6-6608a8a6d182.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www.kroger.com/rx/pharmacy/details/034/00161?cid=loc_03400161P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=10180342282380020627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-pharmacy",
      "poi_latitude": "29.771169",
      "poi_longitude": "-95.599055",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-497-3565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a996-7675-a52a-83b25e78ef58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a996-7675-a52a-83b25e78ef58",
        "storage_key": "property/5191322281443328/019f1503-a996-7675-a52a-83b25e78ef58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu025bnnbQIYRk4smOV7XR40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_1990285ff83cd49c80504084",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1111 Eldridge Pkwy, Houston, TX 77077, USA",
      "poi_short_description": "Fitness center chain offering group classes that combine cardio and strength training.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-6534-7439-b04e-c36f24b2c0fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-6534-7439-b04e-c36f24b2c0fc",
        "storage_key": "property/5191322281443328/019f1503-6534-7439-b04e-c36f24b2c0fc.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/houston-texas-1316?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=8212220293025576950&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "29.7678532",
      "poi_longitude": "-95.6231098",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 832-916-2745",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9f-76db-9d86-a9f8c05ad427",
        "storage_key": "property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ22l2ql7bQIYR9jcLp9iq93E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_a916cefc890bfdb81a327231",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "The Well Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "13610 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-66d0-72bf-a5a2-a524b6f67fe3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-66d0-72bf-a5a2-a524b6f67fe3",
        "storage_key": "property/5191322281443328/019f1503-66d0-72bf-a5a2-a524b6f67fe3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://thewellpilatesstudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18106420185996058976&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-well-pilates",
      "poi_latitude": "29.7731151",
      "poi_longitude": "-95.5806884",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 832-967-5303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac1-731a-af2c-6d7caf4d3b9a",
        "storage_key": "property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiZBjznrbQIYRYOFBLDrtRvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_517140bdfd5a40b3dca19dec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Terry Hershey Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15200 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "Extensive network of hiking & biking trails along a stretch of Buffalo Bayou encompassing 500 acres.",
      "poi_long_description": "Extensive network of hiking & biking trails along a stretch of Buffalo Bayou encompassing 500 acres.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f14ff-f709-7158-8d59-4630319276c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-f709-7158-8d59-4630319276c7",
        "storage_key": "property/5191322281443328/019f14ff-f709-7158-8d59-4630319276c7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://cp4.harriscountytx.gov/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=839903759849692222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "terry-hershey-park",
      "poi_latitude": "29.7817875",
      "poi_longitude": "-95.623719",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9c-73e9-a81e-1e0b6818ab5c",
        "storage_key": "property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnSEHspTbQIYRPhxbAwXwpws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6b3637ffe0c6373d90c1c9f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Edith L Moore Nature Sanctuary",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "440 Wilchester Blvd, Houston, TX 77079, USA",
      "poi_short_description": "Privately-owned forest reserve & wildlife haven spanning 18 acres with an educational nature trail.",
      "poi_long_description": "Privately-owned forest reserve & wildlife haven spanning 18 acres with an educational nature trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-6fbc-756a-aa8e-58f3a76d72b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-6fbc-756a-aa8e-58f3a76d72b3",
        "storage_key": "property/5191322281443328/019f1503-6fbc-756a-aa8e-58f3a76d72b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://houstonaudubon.org/conservation/sanctuaries/edith-moore/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787825092045602411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edith-l-moore-nature-sanctuary",
      "poi_latitude": "29.7706834",
      "poi_longitude": "-95.5683116",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 713-932-1639",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9c-73e9-a81e-1e0b6818ab5c",
        "storage_key": "property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI9XyNFHbQIYRa36wOtoOkTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_d83d6e03e961fb4ca8db79fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Nottingham Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14205 Kimberley Ln, Houston, TX 77079, USA",
      "poi_short_description": "Popular 22-acre area features a splash park, playground, 12-hole disc golf course & tennis courts.",
      "poi_long_description": "Popular 22-acre area features a splash park, playground, 12-hole disc golf course & tennis courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-6eff-710e-aa83-25a009883d93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-6eff-710e-aa83-25a009883d93",
        "storage_key": "property/5191322281443328/019f1503-6eff-710e-aa83-25a009883d93.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://cp4.harriscountytx.gov/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=9767241299191602211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nottingham-park",
      "poi_latitude": "29.7759158",
      "poi_longitude": "-95.5971155",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9c-73e9-a81e-1e0b6818ab5c",
        "storage_key": "property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ20q2lXDbQIYRIxzXaTY2jIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_837ae0d9b5c375592d4f19b4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Energy Corridor Trailhead Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7816236785786176446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "energy-corridor-trailhead-park",
      "poi_latitude": "29.77246229999999",
      "poi_longitude": "-95.6201432",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9c-73e9-a81e-1e0b6818ab5c",
        "storage_key": "property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMzO7YgXbQIYRvkMgyfHZeGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f8e10321167eed8d08cb4ca5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Memorial West Pocket Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16077443495991703510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-west-pocket-park",
      "poi_latitude": "29.77263629999999",
      "poi_longitude": "-95.5883994",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9c-73e9-a81e-1e0b6818ab5c",
        "storage_key": "property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJa4WpaRfbQIYR1vf_eq2NHt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4ebbf1e279b2cde3b7ea65e7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Bendwood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12700 Kimberley Ln, Houston, TX 77024, USA",
      "poi_short_description": "Popular large park featuring playgrounds, basketball courts, picnic areas & more.",
      "poi_long_description": "Popular large park featuring playgrounds, basketball courts, picnic areas & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-76c0-743a-8ebc-7fa01e10c9a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-76c0-743a-8ebc-7fa01e10c9a9",
        "storage_key": "property/5191322281443328/019f1503-76c0-743a-8ebc-7fa01e10c9a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10877627267382722525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bendwood-park",
      "poi_latitude": "29.7769781",
      "poi_longitude": "-95.5568058",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9c-73e9-a81e-1e0b6818ab5c",
        "storage_key": "property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgz-oAbLEQIYR3T9zF14Y9ZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_b5665feb5df4f2377c73ce9a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "George Bush Park Bike Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16756 Westheimer Pkwy, Houston, TX 77082, USA",
      "poi_short_description": "Family-friendly park with scenic views and a long trail for walking, biking or running.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-8283-770e-8714-104da5710462.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-8283-770e-8714-104da5710462",
        "storage_key": "property/5191322281443328/019f1503-8283-770e-8714-104da5710462.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=469630594180836084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-bush-park-bike-trail",
      "poi_latitude": "29.7236788",
      "poi_longitude": "-95.6875102",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9c-73e9-a81e-1e0b6818ab5c",
        "storage_key": "property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9-5hIuDeQIYR9OrNhYl2hAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a2b4ca4b3fddf0ff9c1c5796",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Bear Creek Pioneers Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15015 Clay Rd, Houston, TX 77084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-6f51-72b9-a489-991b3ccda428.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-6f51-72b9-a489-991b3ccda428",
        "storage_key": "property/5191322281443328/019f1503-6f51-72b9-a489-991b3ccda428.webp",
        "width": 1200,
        "height": 918
      },
      "poi_business_url": "https://hcp4.net/parks/bear-creek-pioneers-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5677158900938484850&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-creek-pioneers-park",
      "poi_latitude": "29.8360475",
      "poi_longitude": "-95.6172192",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9c-73e9-a81e-1e0b6818ab5c",
        "storage_key": "property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVbPv1MrbQIYRcqziB_FRyU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_bfacd376e82ff5be34b25596",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Molly Pryor Memorial Orchard",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15200 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "Compact county park with a trellis, gazebo, ornamental garden & walking trail.",
      "poi_long_description": "Compact county park with a trellis, gazebo, ornamental garden & walking trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-7f4d-73b9-9537-e250fcbef677.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-7f4d-73b9-9537-e250fcbef677",
        "storage_key": "property/5191322281443328/019f1503-7f4d-73b9-9537-e250fcbef677.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://cp4.harriscountytx.gov/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=481790785141622011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "molly-pryor-memorial-orchard",
      "poi_latitude": "29.7787225",
      "poi_longitude": "-95.6230158",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9c-73e9-a81e-1e0b6818ab5c",
        "storage_key": "property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnSEHspTbQIYR-0RsnCqqrwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_06b50855c35d84e73f8af009",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Buffalo Bayou Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "105 Sabine St, Houston, TX 77007, USA",
      "poi_short_description": "Winding, 160-acre green space featuring views of the Houston skyline plus a fountain & a skate park.",
      "poi_long_description": "Winding, 160-acre green space featuring views of the Houston skyline plus a fountain & a skate park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-853f-721e-88c3-105fd258771b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-853f-721e-88c3-105fd258771b",
        "storage_key": "property/5191322281443328/019f1503-853f-721e-88c3-105fd258771b.webp",
        "width": 1280,
        "height": 775
      },
      "poi_business_url": "https://buffalobayou.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1178324889902542974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buffalo-bayou-park",
      "poi_latitude": "29.763078",
      "poi_longitude": "-95.3761455",
      "poi_miles_from_property": "18.0 mi",
      "poi_walking_minutes": "6 hours 41 mins",
      "poi_biking_minutes": "1 hour 48 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 713-752-0314 ext. 301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9c-73e9-a81e-1e0b6818ab5c",
        "storage_key": "property/5191322281443328/019f1500-2a9c-73e9-a81e-1e0b6818ab5c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-zLaJqjAQIYRfnCkjD5AWhA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ec664572b7c62f877228cfa2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Addicks Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "14230 Old Katy Rd, Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-7ef2-74ff-bd59-3f15f2597abe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-7ef2-74ff-bd59-3f15f2597abe",
        "storage_key": "property/5191322281443328/019f1503-7ef2-74ff-bd59-3f15f2597abe.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6059542481948761620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "addicks-park--ride",
      "poi_latitude": "29.7872884",
      "poi_longitude": "-95.6383329",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a997-7379-87b4-21571883fb4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a997-7379-87b4-21571883fb4e",
        "storage_key": "property/5191322281443328/019f1503-a997-7379-87b4-21571883fb4e.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1xDFp93bQIYRFN7xUcjRF1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_c4c287a0aee8736bdae39ad8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Grand Parkway Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "1030 N Grand Pkwy, Katy, TX 77449, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-8a41-733a-9630-a37260aeba17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-8a41-733a-9630-a37260aeba17",
        "storage_key": "property/5191322281443328/019f1503-8a41-733a-9630-a37260aeba17.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4263015384683988709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grand-parkway-park--ride",
      "poi_latitude": "29.7876219",
      "poi_longitude": "-95.7760204",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a997-7379-87b4-21571883fb4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a997-7379-87b4-21571883fb4e",
        "storage_key": "property/5191322281443328/019f1503-a997-7379-87b4-21571883fb4e.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5-7oUuImQYYR5UYd7OdFKTs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_8ca4a9ef362fad0948138f83",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Kingsland Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "21669 Kingsland Blvd, Katy, TX 77450, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-8bde-70c2-828f-05efc0c051bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-8bde-70c2-828f-05efc0c051bf",
        "storage_key": "property/5191322281443328/019f1503-8bde-70c2-828f-05efc0c051bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16228968268042078283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kingsland-park--ride",
      "poi_latitude": "29.7747945",
      "poi_longitude": "-95.7449571",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a997-7379-87b4-21571883fb4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a997-7379-87b4-21571883fb4e",
        "storage_key": "property/5191322281443328/019f1503-a997-7379-87b4-21571883fb4e.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJfz3tbkQnQYYRSwi8r6fgOOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_9d842b1c04aa960d969eea89",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Gessner Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "9925 Westpark Dr, Houston, TX 77063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-8cab-769a-b862-e473b099361b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-8cab-769a-b862-e473b099361b",
        "storage_key": "property/5191322281443328/019f1503-8cab-769a-b862-e473b099361b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8759854959400057547&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gessner-park-and-ride",
      "poi_latitude": "29.72044959999999",
      "poi_longitude": "-95.5374292",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a997-7379-87b4-21571883fb4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a997-7379-87b4-21571883fb4e",
        "storage_key": "property/5191322281443328/019f1503-a997-7379-87b4-21571883fb4e.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJYdfhzB_DQIYRy_r7gqxBkXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_1044f350ab5c12608c553a01",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Westchase Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "11050 Harwin Dr., Houston, TX 77072, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-90a5-756c-840b-a3f7cf19ab0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-90a5-756c-840b-a3f7cf19ab0b",
        "storage_key": "property/5191322281443328/019f1503-90a5-756c-840b-a3f7cf19ab0b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5396743279492684688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westchase-park-and-ride",
      "poi_latitude": "29.717204",
      "poi_longitude": "-95.5628297",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a997-7379-87b4-21571883fb4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a997-7379-87b4-21571883fb4e",
        "storage_key": "property/5191322281443328/019f1503-a997-7379-87b4-21571883fb4e.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJIX9fwSrdQIYRkFsjZmsV5Uo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_bf7940ff87ee9ff49d9df726",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Northwest Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "7373 Old Katy Rd, Houston, TX 77024, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-922b-72ce-8e22-8590563e09e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-922b-72ce-8e22-8590563e09e9",
        "storage_key": "property/5191322281443328/019f1503-922b-72ce-8e22-8590563e09e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridemetro.org/pages/TC-Northwest.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4887889931563584101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-transit-center",
      "poi_latitude": "29.7833768",
      "poi_longitude": "-95.4545941",
      "poi_miles_from_property": "11.8 mi",
      "poi_walking_minutes": "4 hours 24 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9f-76db-9d86-a9f8c05ad427",
        "storage_key": "property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq3DSrsfGQIYRZUoO4P5F1UM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_225b349ce470ef3aa0d86256",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Northwest Station Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "18502 Northwest Fwy, Houston, TX 77065, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-9798-71e5-9297-b5763111292e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-9798-71e5-9297-b5763111292e",
        "storage_key": "property/5191322281443328/019f1503-9798-71e5-9297-b5763111292e.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15540130698840525853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-station-park--ride",
      "poi_latitude": "29.90224199999999",
      "poi_longitude": "-95.5940473",
      "poi_miles_from_property": "11.2 mi",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a997-7379-87b4-21571883fb4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a997-7379-87b4-21571883fb4e",
        "storage_key": "property/5191322281443328/019f1503-a997-7379-87b4-21571883fb4e.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yxMh1LQQIYRHUyIE4miqdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_c095b507202025a0cacea015",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Cypress Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "25210 US-290 Frontage Rd., Cypress, TX 77429, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-9723-70fd-80ad-370242b85cdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-9723-70fd-80ad-370242b85cdf",
        "storage_key": "property/5191322281443328/019f1503-9723-70fd-80ad-370242b85cdf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8813123989977222512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cypress-park--ride",
      "poi_latitude": "29.9641577",
      "poi_longitude": "-95.6855147",
      "poi_miles_from_property": "15.5 mi",
      "poi_walking_minutes": "5 hours 45 mins",
      "poi_biking_minutes": "1 hour 42 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a997-7379-87b4-21571883fb4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a997-7379-87b4-21571883fb4e",
        "storage_key": "property/5191322281443328/019f1503-a997-7379-87b4-21571883fb4e.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ39ayTa3RQIYRcM0QMJOBTno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_a27591b9d14f14fd41971d7e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "George Bush Intercontinental Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2800 N Terminal Rd, Houston, TX 77032, USA",
      "poi_short_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_long_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-979e-71eb-83aa-1f7f0b313281.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-979e-71eb-83aa-1f7f0b313281",
        "storage_key": "property/5191322281443328/019f1503-979e-71eb-83aa-1f7f0b313281.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fly2houston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11296915713098302001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-bush-intercontinental-airport",
      "poi_latitude": "29.9931058",
      "poi_longitude": "-95.3416255",
      "poi_miles_from_property": "33.5 mi",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "2 hours 58 mins",
      "poi_driving_minutes": "40 mins",
      "poi_business_phone": "+1 281-230-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac5-7377-aa5d-2db24d4699f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac5-7377-aa5d-2db24d4699f0",
        "storage_key": "property/5191322281443328/019f1500-2ac5-7377-aa5d-2db24d4699f0.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1VD2SO0QIYRMcLAyPy0xpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_abb2a072cc42eba5941fe81e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "bp - North America Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "501 Westlake Park Blvd, Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15185058292890461683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bp---north-america-inc",
      "poi_latitude": "29.781243",
      "poi_longitude": "-95.6287913",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-366-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9f-76db-9d86-a9f8c05ad427",
        "storage_key": "property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR4gT6fjbQIYR8-VVQRAqvNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_99d2b9600a64c423915672a3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Shell Woodcreek Complex",
      "poi_type": "Major Employers & Offices",
      "poi_address": "150 N Dairy Ashford Rd, Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-03f9-77e3-9468-28ac4a0eb3a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-03f9-77e3-9468-28ac4a0eb3a1",
        "storage_key": "property/5191322281443328/019f1500-03f9-77e3-9468-28ac4a0eb3a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.shell.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6245627658790227837&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shell-woodcreek-complex",
      "poi_latitude": "29.7876018",
      "poi_longitude": "-95.6045079",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 832-337-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9f-76db-9d86-a9f8c05ad427",
        "storage_key": "property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7d-a7qHbQIYRfc-L0UPtrFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_2a1285c1b2518c299b639795",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Houston Methodist Willowbrook Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "18220 TX-249, Houston, TX 77070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-9858-74dd-83d5-156b918c21e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-9858-74dd-83d5-156b918c21e2",
        "storage_key": "property/5191322281443328/019f1503-9858-74dd-83d5-156b918c21e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.houstonmethodist.org/locations/willowbrook/?utm_source=gmb&utm_medium=organic&utm_campaign=all_location_gmb&utm_content=website-click",
      "poi_directions_map_url": "https://maps.google.com/?cid=10196221651682341886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-methodist-willowbrook-hospital",
      "poi_latitude": "29.967329",
      "poi_longitude": "-95.5504867",
      "poi_miles_from_property": "18.4 mi",
      "poi_walking_minutes": "6 hours 51 mins",
      "poi_biking_minutes": "1 hour 47 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 281-737-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac1-731a-af2c-69e3064f7be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac1-731a-af2c-69e3064f7be0",
        "storage_key": "property/5191322281443328/019f1500-2ac1-731a-af2c-69e3064f7be0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ49I-IO7NQIYR_jOs_5FBgI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_f1b4ebc07b0684fc1993daf5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "HCA Houston Healthcare Tomball",
      "poi_type": "Major Employers & Offices",
      "poi_address": "605 Holderrieth Blvd, Tomball, TX 77375, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-94e4-755a-a4d7-de2d65b8533c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-94e4-755a-a4d7-de2d65b8533c",
        "storage_key": "property/5191322281443328/019f1503-94e4-755a-a4d7-de2d65b8533c.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/tomball?utm__campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=5498663179337216239&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-healthcare-tomball",
      "poi_latitude": "30.087482",
      "poi_longitude": "-95.6237425",
      "poi_miles_from_property": "23.7 mi",
      "poi_walking_minutes": "8 hours 48 mins",
      "poi_biking_minutes": "2 hours 20 mins",
      "poi_driving_minutes": "37 mins",
      "poi_business_phone": "+1 281-401-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac1-731a-af2c-69e3064f7be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac1-731a-af2c-69e3064f7be0",
        "storage_key": "property/5191322281443328/019f1500-2ac1-731a-af2c-69e3064f7be0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVeNEl8sR4YR7zDqRwctT0w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_b0660fca8e0dd77394c0c59f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Lone Star College-Tomball",
      "poi_type": "Major Employers & Offices",
      "poi_address": "30555 Tomball Pkwy, Tomball, TX 77375, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-985b-771c-a811-f96d62818077.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-985b-771c-a811-f96d62818077",
        "storage_key": "property/5191322281443328/019f1503-985b-771c-a811-f96d62818077.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.lonestar.edu/tomball",
      "poi_directions_map_url": "https://maps.google.com/?cid=14727415843202182545&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lone-star-college-tomball",
      "poi_latitude": "30.11045",
      "poi_longitude": "-95.6445371",
      "poi_miles_from_property": "25.0 mi",
      "poi_walking_minutes": "9 hours 13 mins",
      "poi_biking_minutes": "2 hours 31 mins",
      "poi_driving_minutes": "38 mins",
      "poi_business_phone": "+1 281-351-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac1-731a-af2c-6d7caf4d3b9a",
        "storage_key": "property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf2XPWwosR4YRka2GIa5KYsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_910d1e02ac49d13272cd4344",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Memorial Hermann Memorial City Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "921 Gessner Rd, Houston, TX 77024, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a0bb-752d-a49d-3e9a3b1fccc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-a0bb-752d-a49d-3e9a3b1fccc6",
        "storage_key": "property/5191322281443328/019f1503-a0bb-752d-a49d-3e9a3b1fccc6.webp",
        "width": 1004,
        "height": 1280
      },
      "poi_business_url": "https://memorialhermann.org/locations/memorial-city?utm_campaign=reputation-management&utm_segment=gmb_location-listing&utm_source=yext&utm_medium=organic-search",
      "poi_directions_map_url": "https://maps.google.com/?cid=7341386861309126237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-memorial-city-medical-center",
      "poi_latitude": "29.780343",
      "poi_longitude": "-95.5469103",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 713-242-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac1-731a-af2c-69e3064f7be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac1-731a-af2c-69e3064f7be0",
        "storage_key": "property/5191322281443328/019f1500-2ac1-731a-af2c-69e3064f7be0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQQQlc7zEQIYRXeYMO3TY4WU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_653d55c855a156942b2a9cde",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "HCA Houston Healthcare North Cypress",
      "poi_type": "Major Employers & Offices",
      "poi_address": "21214 Northwest Fwy, Cypress, TX 77429, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-9d26-74ec-b1a7-597279a08057.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-9d26-74ec-b1a7-597279a08057",
        "storage_key": "property/5191322281443328/019f1503-9d26-74ec-b1a7-597279a08057.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/north-cypress?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=5610823420399779988&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-healthcare-north-cypress",
      "poi_latitude": "29.9260732",
      "poi_longitude": "-95.6311018",
      "poi_miles_from_property": "11.1 mi",
      "poi_walking_minutes": "4 hours 6 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 832-912-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac1-731a-af2c-69e3064f7be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac1-731a-af2c-69e3064f7be0",
        "storage_key": "property/5191322281443328/019f1500-2ac1-731a-af2c-69e3064f7be0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-SuGEfRQIYRlABfZiym3U0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_ada726afc6c2ac27df56d195",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Memorial Hermann Cypress Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "27800 Northwest Fwy, Cypress, TX 77433, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a1cc-730e-be9e-661f8e6a5b21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-a1cc-730e-be9e-661f8e6a5b21",
        "storage_key": "property/5191322281443328/019f1503-a1cc-730e-be9e-661f8e6a5b21.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://memorialhermann.org/locations/cypress/?utm_campaign=reputation-management&utm_segment=gmb_location-listing&utm_source=yext&utm_medium=organic-search",
      "poi_directions_map_url": "https://maps.google.com/?cid=2875916857937908689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-cypress-hospital",
      "poi_latitude": "29.9869462",
      "poi_longitude": "-95.7333276",
      "poi_miles_from_property": "19.5 mi",
      "poi_walking_minutes": "7 hours 12 mins",
      "poi_biking_minutes": "1 hour 51 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 346-231-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac1-731a-af2c-69e3064f7be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac1-731a-af2c-69e3064f7be0",
        "storage_key": "property/5191322281443328/019f1500-2ac1-731a-af2c-69e3064f7be0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJFREKC34qQYYR0VPyICVP6Sc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_382d7598f7a375708599b309",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "ExxonMobil Houston Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "22777 Springwoods Village Pkwy, Spring, TX 77389, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a2f7-718c-8e83-e405653755ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-a2f7-718c-8e83-e405653755ec",
        "storage_key": "property/5191322281443328/019f1503-a2f7-718c-8e83-e405653755ec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://corporate.exxonmobil.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4652161626967610876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "exxonmobil-houston-campus",
      "poi_latitude": "30.1032818",
      "poi_longitude": "-95.4463252",
      "poi_miles_from_property": "32.2 mi",
      "poi_walking_minutes": "11 hours 53 mins",
      "poi_biking_minutes": "2 hours 44 mins",
      "poi_driving_minutes": "43 mins",
      "poi_business_phone": "+1 800-582-3645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a9f-76db-9d86-a9f8c05ad427",
        "storage_key": "property/5191322281443328/019f1500-2a9f-76db-9d86-a9f8c05ad427.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwbXzI1A0R4YR_JUb_VnMj0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_15535b37ccc28d3854b3c110",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "poi_name": "Mark Henry Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11440 Matzke Rd, Cypress, TX 77429, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1503-a341-7042-ae7f-008e60d9161e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-a341-7042-ae7f-008e60d9161e",
        "storage_key": "property/5191322281443328/019f1503-a341-7042-ae7f-008e60d9161e.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://www.cfisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8141921204904058597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mark-henry-administration-building",
      "poi_latitude": "29.944362",
      "poi_longitude": "-95.6566466",
      "poi_miles_from_property": "12.0 mi",
      "poi_walking_minutes": "4 hours 26 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 281-897-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2ac1-731a-af2c-6d7caf4d3b9a",
        "storage_key": "property/5191322281443328/019f1500-2ac1-731a-af2c-6d7caf4d3b9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyYKhs0_XQIYR5d6GtzLq_XA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_25ecced8-b7b0-4e47-9bef-5d18346b8e86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_113bf12d-fcf2-4da2-99a5-a5368b608ac9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_034362e7-d06e-4282-a4e4-7aae673c68d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c0ef1676-2a6c-45e2-999c-056cf2d10abb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_8b14f556-bdf5-4b8c-b8bd-4fb6678fd0a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_2270d574-972d-48cb-beee-8f6c88593e11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "19:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_dec0c0c0-5f27-4271-bc21-0548881883a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "rating": "5.0",
      "name": "Karla LeRod",
      "text": "I LOVE LOVE MY APARTMENT!! The staff, I had an issue with my sink and it was fixed less than 24hrs, they keep you up to date, they plan events MONTHLY and sometimes twice a month!! I regret not signing 2 year lease haha!! Ask for Aileen she’s AMAZING!!!",
      "date": "2026-06-04",
      "title": ""
    },
    {
      "id": "custom_022f6914-eff6-405c-8d3d-b705545d43fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "rating": "5.0",
      "name": "Brittany Robinson",
      "text": "I want to take the time to recognize Keyana for being an exceptional assistant community manager! She immediately stood out to me because she didn’t mind showing me multiple units while touring. Sometimes it is a hassle to see ONE at other places. She went above and beyond to make sure I could move in by the date set, and has checked up on me several times since to ensure my move in was smooth and everything was going well so far. I really appreciate the friendly service and warm welcome that has been extended to me. Anytime I see her, she’s smiling big and happy to help. I love that the property is well maintained, and has community wide cleaning days. I haven’t had any issues since moving in and I’m proud to say that I enjoy living here. Thank you Keyana & the entire Neo at Ten team!",
      "date": "2026-05-27",
      "title": ""
    },
    {
      "id": "custom_68d2aa6a-149c-42f4-bfd2-5b5a336178e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "rating": "5.0",
      "name": "Dr. Sierra Hobbs",
      "text": "I recently moved into the community and felt it was important to share this.\n\nWithin my first 24 hours, I ran into an unexpected issue in my original unit. I’ll be honest — it was frustrating and a little overwhelming in the moment. But what really stood out to me was how the leasing and management team responded.\n\nFrom the time I reached out, Keli, Elizabeth, and Keyana were kind, understanding, and quick to act. I didn’t feel dismissed or brushed off — I felt heard. They worked with me, kept communication open, and ultimately helped me transition into another unit that I absolutely love.\n\nThe process was smooth, and they made what could have been a stressful situation feel manageable. That level of care and responsiveness really matters, especially during a move.\n\nI’m grateful for how everything was handled and for a team that truly showed up when it counted. They truly made me feel like I made the right decision moving here.",
      "date": "2026-04-24",
      "title": ""
    },
    {
      "id": "custom_66eb9aa0-6fda-42d5-95e3-8cd3d023ce1f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "rating": "5.0",
      "name": "Chris",
      "text": "Who wouldn't love to live here with a view and access like this...very relaxing...the staff is very responsive to your needs. They have been very caring for my girls...Koda and Pippie...my dogs...lol.",
      "date": "2026-02-27",
      "title": ""
    },
    {
      "id": "custom_afc89753-316f-4cb3-a51e-51588defe63a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "rating": "5.0",
      "name": "Kenyatta Battle",
      "text": "I had an amazing experience working with Keyana Warner, the leasing agent and assistant manager. From start to finish, she was professional, responsive, and genuinely supportive throughout the entire leasing process. She took the time to explain everything clearly, answered all of my questions, and made sure I felt confident at every step.\n\nKeyana went above and beyond to help me get approved for my apartment, and her communication and attention to detail made what can be a stressful process feel smooth and easy. You can tell she truly cares about her residents and takes pride in her work.\n\nIf you’re looking for someone who is knowledgeable, patient, and dedicated, I highly recommend working with Keyana. She made a huge difference in my experience, and I’m very grateful for her help.",
      "date": "2025-12-31",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_96268a1741d683ce19dba791",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019d02ee-598f-7428-98d6-dc6bb950603e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen island with granite countertops, stainless steel dishwasher, and sink overlooking living room and bedroom.",
        "public_id": "019d02ee-598f-7428-98d6-dc6bb950603e",
        "storage_key": "property/5191322281443328/019d02ee-598f-7428-98d6-dc6bb950603e.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "1BR, 1BA - 816SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=SffyKh8GFsc"
    },
    {
      "id": "ec_373fd034f03699b9f0ebba89",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f14c3-c913-73ec-9aac-bba6ff4b672c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-c913-73ec-9aac-bba6ff4b672c",
        "storage_key": "property/5191322281443328/019f14c3-c913-73ec-9aac-bba6ff4b672c.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Neo @ 10 | Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/r2atjvt8iqc"
    },
    {
      "id": "ec_14c886632eeb976210f74b5b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f14c3-c815-759c-88c3-4cb30d61808f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-c815-759c-88c3-4cb30d61808f",
        "storage_key": "property/5191322281443328/019f14c3-c815-759c-88c3-4cb30d61808f.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "2BR, 2BA - 1163SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=K49JaZr3Q2c"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-c0d5-778a-a6c0-4587650802c6",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "neo-at-ten",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328"
    },
    {
      "lead_collector_id": "0198aa45-c137-750a-b68d-92d569aa4663",
      "lead_source": "FACEBOOK_ADS",
      "name": "neo-at-ten",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328"
    },
    {
      "lead_collector_id": "0198aa45-c19a-7399-8d50-4479c2864eb0",
      "lead_source": "LANDING_PAGE",
      "name": "neo-at-ten",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "page_item_url": "discover-one-bedroom-apartments-for-rent-houston-tx",
      "search_query": "One Bedroom Apartments For Rent in Houston, TX",
      "category": "Floorplan",
      "h1_title": "Discover One Bedroom Apartments For Rent in Houston, TX",
      "h2_subtitle": "NEO at Ten offers modern living in the heart of Houston's Energy Corridor. Experience luxury with our top-tier amenities and stylish apartment features.",
      "page_copy": "Welcome to NEO at Ten, where you can find exceptional one bedroom apartments for rent in Houston, TX. Our community is perfectly situated in the vibrant Energy Corridor, providing easy access to everything you need. Each apartment home features stunning finishes, including stainless steel appliances, granite countertops, and pendant lighting, ensuring a sophisticated living experience. \n\nResidents enjoy a variety of amenities, such as a clubhouse with a business center and fitness center, as well as an outdoor kitchen ideal for social gatherings. With washer/dryer units, vinyl flooring, and private balconies, NEO at Ten offers the perfect blend of comfort and convenience. Discover your new home today and enjoy the best of Houston living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs.",
        "public_id": "019f6c0f-f7b9-768c-8ae2-d69ffb932d06",
        "storage_key": "property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c10-017c-7669-9381-1165906a63c8",
        "storage_key": "property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "NEO at Ten | One Bedroom Apartments For Rent in Houston TX",
      "seo_description": "Explore NEO at Ten's one bedroom apartments for rent in Houston TX. Enjoy luxury finishes and amenities in the Energy Corridor. Discover your new home today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "page_item_url": "explore-two-bedrooms-apartments-for-rent-houston-tx",
      "search_query": "Two Bedrooms Apartments For Rent in Houston, TX",
      "category": "Floorplan",
      "h1_title": "Explore Two Bedrooms Apartments For Rent in Houston, TX",
      "h2_subtitle": "NEO at Ten provides spacious two-bedroom apartments in Houston's Energy Corridor. Enjoy upscale living with our premium amenities and stylish interiors.",
      "page_copy": "Welcome to NEO at Ten, where you can find exceptional two bedrooms apartments for rent in Houston, TX. Located in the bustling Energy Corridor, our community offers easy access to the city's best dining, shopping, and entertainment. Each apartment is designed with modern finishes, including stainless steel appliances, granite countertops, and pendant lighting, creating a luxurious living environment. \n\nOur residents benefit from a range of amenities, such as a clubhouse with a business center and fitness center, and an outdoor kitchen perfect for entertaining. With features like washer/dryer units, vinyl flooring, and private balconies, NEO at Ten ensures a comfortable and convenient lifestyle. Discover your ideal home today and experience the vibrant Houston lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs.",
        "public_id": "019f6c0f-f7b9-768c-8ae2-d69ffb932d06",
        "storage_key": "property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c10-017c-7669-9381-1165906a63c8",
        "storage_key": "property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "NEO at Ten | Two Bedrooms Apartments For Rent in Houston, TX",
      "seo_description": "Discover NEO at Ten's two bedrooms apartments for rent in Houston TX. Enjoy luxury finishes and amenities in the Energy Corridor. Find your perfect home today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-pool-at-neo",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Pool in Houston, TX",
      "h2_subtitle": "NEO at Ten offers luxurious living with a refreshing pool in Houston's Energy Corridor. Enjoy modern amenities and stylish interiors in our vibrant community.",
      "page_copy": "Discover NEO at Ten, the perfect choice for those seeking apartments for rent in Houston, TX, with a swimming pool. Nestled in the Energy Corridor, our community offers a serene escape complete with upscale amenities. Dive into relaxation at our sparkling pool, or unwind in the Zen garden—your peaceful retreat from the city’s hustle and bustle.\n\nResidents also enjoy access to a state-of-the-art fitness center, a welcoming clubhouse, and a business center for professional needs. With one- and two-bedroom floor plans, each apartment boasts modern finishes like stainless steel appliances and granite countertops. Experience the best of Houston living at NEO at Ten, where comfort, convenience, and luxury come together.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs.",
        "public_id": "019f6c0f-f7b9-768c-8ae2-d69ffb932d06",
        "storage_key": "property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c10-017c-7669-9381-1165906a63c8",
        "storage_key": "property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "NEO at Ten | Apartments For Rent with Pool",
      "seo_description": "Explore NEO at Ten's apartments for rent with a pool in Houston, TX. Enjoy luxury amenities and modern living in the Energy Corridor. Find your new home today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Fitness Center at NEO at Ten",
      "h2_subtitle": "NEO at Ten offers modern living with a state-of-the-art fitness center in Houston's Energy Corridor. Enjoy upscale amenities and stylish apartment features.",
      "page_copy": "Welcome to NEO at Ten, your ideal destination for apartments for rent near me with fitness center in Houston, TX. Located in the vibrant Energy Corridor, our community provides residents with access to a fully equipped fitness center, perfect for maintaining an active lifestyle. In addition to the fitness center, enjoy a variety of amenities including a pool, clubhouse, and business center. \n\nOur one and two-bedroom apartments feature modern finishes such as stainless steel appliances, granite countertops, and pendant lighting, ensuring a luxurious living experience. With a Zen garden and outdoor kitchen, NEO at Ten offers a perfect blend of relaxation and convenience. Discover your new home today and experience the best of Houston living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs.",
        "public_id": "019f6c0f-f7b9-768c-8ae2-d69ffb932d06",
        "storage_key": "property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c10-017c-7669-9381-1165906a63c8",
        "storage_key": "property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "NEO at Ten | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Explore NEO at Ten's apartments for rent with a fitness center in Houston, TX. Enjoy luxury amenities and modern living in the Energy Corridor.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-houston-tx-near-texas-childrens-hospital",
      "search_query": "Apartments near Texas Children's Hospital West Campus",
      "category": "POI",
      "h1_title": "Find Apartments For Rent in Houston, TX, near Texas Children's Hospital West Campus",
      "h2_subtitle": "NEO at Ten offers convenient living near Texas Children's Hospital West Campus in Houston's Energy Corridor. Enjoy modern amenities and stylish apartment features.",
      "page_copy": "Welcome to NEO at Ten, where you can find apartments for rent in Houston, TX, near Texas Children's Hospital West Campus. Located in the vibrant Energy Corridor, our community provides easy access to the expert care offered by Texas Children's Hospital, making it an ideal choice for families and healthcare professionals. Each apartment home features modern finishes such as stainless steel appliances, granite countertops, and pendant lighting, ensuring a luxurious living experience. \n\nResidents enjoy a variety of amenities, including a fitness center, clubhouse, and a serene Zen garden. With one and two-bedroom floor plans available, NEO at Ten offers the perfect blend of comfort and convenience. Our community is designed to meet all your needs, from a business center to an outdoor kitchen for social gatherings. Discover your new home at NEO at Ten and enjoy the best of Houston living, just moments away from Texas Children's Hospital West Campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs.",
        "public_id": "019f6c0f-f7b9-768c-8ae2-d69ffb932d06",
        "storage_key": "property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c10-017c-7669-9381-1165906a63c8",
        "storage_key": "property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "NEO at Ten | Apts near Texas Children's Hospital West Campus",
      "seo_description": "Explore NEO at Ten's one- and two-bedroom apartments for rent in Houston, TX, conveniently located near Texas Children's Hospital West Campus.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-houston-tx-near-aesthetic-center",
      "search_query": "Apartments For Rent in Houston, TX, Near Aesthetic Center for Plastic Surgery",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent in Houston, TX, Near Aesthetic Center for Plastic Surgery",
      "h2_subtitle": "NEO at Ten offers stylish living near the Aesthetic Center for Plastic Surgery in Houston's Energy Corridor. Enjoy modern amenities and luxurious apartment features.",
      "page_copy": "Welcome to NEO at Ten, where you can find apartments for rent in Houston, TX, near the Aesthetic Center for Plastic Surgery. Each apartment home features modern finishes such as stainless steel appliances, granite countertops, and pendant lighting, ensuring a sophisticated living experience. \n\nResidents enjoy a variety of amenities, including a fitness center, clubhouse, and a tranquil Zen garden. With one and two-bedroom floor plans available, NEO at Ten offers the perfect blend of comfort and convenience. Our community is designed to meet all your needs, from a business center to an outdoor kitchen for social gatherings. Discover your new home at NEO at Ten and enjoy the best of Houston living, just moments away from the Aesthetic Center for Plastic Surgery.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs.",
        "public_id": "019f6c0f-f7b9-768c-8ae2-d69ffb932d06",
        "storage_key": "property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c10-017c-7669-9381-1165906a63c8",
        "storage_key": "property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "NEO at Ten | Apts Near Aesthetic Center for Plastic Surgery",
      "seo_description": "Explore NEO at Ten's apartments in Houston, TX, conveniently located near the Aesthetic Center for Plastic Surgery. Enjoy luxury amenities and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-houston-tx-near-philips-medical",
      "search_query": "Apartments For Rent in Houston, TX, Near Philips Medical Services",
      "category": "POI",
      "h1_title": "Find Apartments For Rent in Houston, TX, Near Philips Medical Services",
      "h2_subtitle": "NEO at Ten offers convenient living near Philips Medical Services in Houston's Energy Corridor. Enjoy modern amenities and stylish apartment features.",
      "page_copy": "Welcome to NEO at Ten, where you can find apartments for rent in Houston, TX, near Philips Medical Services. Located in the vibrant Energy Corridor, our community provides easy access to Philips Medical Services, making it an ideal choice for healthcare professionals and those seeking medical services. Each apartment home features modern finishes such as stainless steel appliances, granite countertops, and pendant lighting, ensuring a luxurious living experience. \n\nResidents enjoy a variety of amenities, including a fitness center, clubhouse, and a serene Zen garden. With one and two-bedroom floor plans available, NEO at Ten offers the perfect blend of comfort and convenience. Our community is designed to meet all your needs, from a business center to an outdoor kitchen for social gatherings. Discover your new home at NEO at Ten and enjoy the best of Houston living, just moments away from Philips Medical Services.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs.",
        "public_id": "019f6c0f-f7b9-768c-8ae2-d69ffb932d06",
        "storage_key": "property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c10-017c-7669-9381-1165906a63c8",
        "storage_key": "property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "NEO at Ten | Apartments near Philips Medical Services",
      "seo_description": "Explore NEO at Ten's apartments for rent in Houston, TX, near Philips Medical Services. Enjoy luxury amenities and modern living in the Energy Corridor.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-houston-tx-near-hca-healthcare",
      "search_query": "Apartments For Rent in Houston, TX, Near HCA Houston Healthcare West",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Houston, TX, Near HCA Houston Healthcare West",
      "h2_subtitle": "NEO at Ten offers convenient living near HCA Houston Healthcare West in Houston's Energy Corridor. Enjoy modern amenities and stylish apartment features.",
      "page_copy": "Welcome to NEO at Ten, where you can find apartments for rent in Houston, TX, near HCA Houston Healthcare West. Located in the dynamic Energy Corridor, our community provides easy access to HCA Houston Healthcare West, making it an ideal choice for healthcare professionals and those seeking medical services. Each apartment home features modern finishes such as stainless steel appliances, granite countertops, and pendant lighting, ensuring a luxurious living experience. \n\nResidents enjoy a variety of amenities, including a fitness center, clubhouse, and a serene Zen garden. With one and two-bedroom floor plans available, NEO at Ten offers the perfect blend of comfort and convenience. Our community is designed to meet all your needs, from a business center to an outdoor kitchen for social gatherings. Discover your new home at NEO at Ten and enjoy the best of Houston living, just moments away from HCA Houston Healthcare West.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs.",
        "public_id": "019f6c0f-f7b9-768c-8ae2-d69ffb932d06",
        "storage_key": "property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c10-017c-7669-9381-1165906a63c8",
        "storage_key": "property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "NEO at Ten | Apartments Near HCA Houston Healthcare West",
      "seo_description": "Explore NEO at Ten's apartments for rent in Houston, TX, near HCA Houston Healthcare West. Enjoy luxury amenities and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-houston-tx-near-breath-life-research",
      "search_query": "Apartments For Rent in Houston, TX, Near Breath Life Research Institute",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston, TX, Near Breath Life Research Institute",
      "h2_subtitle": "NEO at Ten offers convenient living near Breath Life Research Institute in Houston's Energy Corridor. Enjoy modern amenities and stylish apartment features.",
      "page_copy": "Welcome to NEO at Ten, where you can find apartments for rent in Houston, TX, near Breath Life Research Institute. Located in the vibrant Energy Corridor, our community provides easy access to the Breath Life Research Institute, making it an ideal choice for professionals and researchers. Each apartment home features modern finishes such as stainless steel appliances, granite countertops, and pendant lighting, ensuring a luxurious living experience. \n\nResidents enjoy a variety of amenities, including a fitness center, clubhouse, and a serene Zen garden. With one and two-bedroom floor plans available, NEO at Ten offers the perfect blend of comfort and convenience. Our community is designed to meet all your needs, from a business center to an outdoor kitchen for social gatherings. Discover your new home at NEO at Ten and enjoy the best of Houston living, just moments away from Breath Life Research Institute.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs.",
        "public_id": "019f6c0f-f7b9-768c-8ae2-d69ffb932d06",
        "storage_key": "property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c10-017c-7669-9381-1165906a63c8",
        "storage_key": "property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "NEO at Ten | Apartments Near Breath Life Research Institute",
      "seo_description": "Explore NEO at Ten's apartments for rent in Houston, TX, near Breath Life Research Institute. Contact us and find your new home today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-houston-tx-near-hcc-katy",
      "search_query": "Apartments For Rent Near HCC - Katy Campus",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Houston, TX, Near HCC - Katy Campus",
      "h2_subtitle": "NEO at Ten offers convenient living near HCC - Katy Campus in Houston's Energy Corridor. Enjoy modern amenities and stylish apartment features.",
      "page_copy": "Welcome to NEO at Ten, where you can find apartments for rent in Houston, TX, near Houston Community College - Katy Campus. Located in the vibrant Energy Corridor, our community provides easy access to HCC - Katy Campus, making it an ideal choice for students and educators. Each apartment home features modern finishes such as stainless steel appliances, granite countertops, and pendant lighting, ensuring a luxurious living experience. \n\nResidents enjoy a variety of amenities, including a fitness center, clubhouse, and a serene Zen garden. With one and two-bedroom floor plans available, NEO at Ten offers the perfect blend of comfort and convenience. Our community is designed to meet all your needs, from a business center to an outdoor kitchen for social gatherings. Discover your new home at NEO at Ten and enjoy the best of Houston living, just moments away from HCC - Katy Campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs.",
        "public_id": "019f6c0f-f7b9-768c-8ae2-d69ffb932d06",
        "storage_key": "property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c10-017c-7669-9381-1165906a63c8",
        "storage_key": "property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "NEO at Ten | Apartments For Rent in Houston, TX, Near HCC",
      "seo_description": "Explore NEO at Ten's apartments in Houston, TX, near HCC - Katy Campus. Enjoy luxury amenities and convenient apartment living in the Energy Corridor.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-houston-tx-near-hcc-stafford",
      "search_query": "Apartments For Rent In Houston, TX, Near Houston Community College - Stafford Campus",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston, TX, Near HCC - Stafford Campus",
      "h2_subtitle": "NEO at Ten offers convenient living near HCC - Stafford Campus in Houston's Energy Corridor. Enjoy modern amenities and stylish apartment features.",
      "page_copy": "Welcome to NEO at Ten, where you can find apartments for rent in Houston, TX, near Houston Community College - Stafford Campus. Located in the vibrant Energy Corridor, our community provides easy access to HCC - Stafford Campus, making it an ideal choice for students and educators. Each apartment home features modern finishes such as stainless steel appliances, granite countertops, and pendant lighting, ensuring a luxurious living experience. \n\nResidents enjoy a variety of amenities, including a fitness center, clubhouse, and a serene Zen garden. With one and two-bedroom floor plans available, NEO at Ten offers the perfect blend of comfort and convenience. Our community is designed to meet all your needs, from a business center to an outdoor kitchen for social gatherings. Discover your new home at NEO at Ten and enjoy the best of Houston living, just moments away from HCC - Stafford Campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs.",
        "public_id": "019f6c0f-f7b9-768c-8ae2-d69ffb932d06",
        "storage_key": "property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c10-017c-7669-9381-1165906a63c8",
        "storage_key": "property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "NEO at Ten | Apartments Near HCC - Stafford Campus",
      "seo_description": "Explore NEO at Ten's apartments for rent in Houston, TX, near HCC - Stafford Campus. Enjoy convenient apartment living in the heart of the Energy Corridor.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-houston-tx-near-hcc",
      "search_query": "Apartments For Rent in Houston, TX, Near Houston Community College - Spring Branch Campus",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Houston, TX, Near HCC - Spring Branch Campus",
      "h2_subtitle": "NEO at Ten offers convenient living near HCC - Spring Branch Campus in Houston's Energy Corridor. Enjoy modern amenities and stylish apartment features.",
      "page_copy": "Welcome to NEO at Ten, where you can find apartments for rent in Houston, TX, near Houston Community College - Spring Branch Campus. Located in the vibrant Energy Corridor, our community provides easy access to HCC - Spring Branch Campus, making it an ideal choice for students and educators. Each apartment home features modern finishes such as stainless steel appliances, granite countertops, and pendant lighting, ensuring a luxurious living experience. \n\nResidents enjoy a variety of amenities, including a fitness center, clubhouse, and a serene Zen garden. With one and two-bedroom floor plans available, NEO at Ten offers the perfect blend of comfort and convenience. Our community is designed to meet all your needs, from a business center to an outdoor kitchen for social gatherings. Discover your new home at NEO at Ten and enjoy the best of Houston living, just moments away from HCC - Spring Branch Campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs.",
        "public_id": "019f6c0f-f7b9-768c-8ae2-d69ffb932d06",
        "storage_key": "property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c10-017c-7669-9381-1165906a63c8",
        "storage_key": "property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "NEO at Ten | Apartments Near HCC - Spring Branch Campus",
      "seo_description": "Explore NEO at Ten's apartments for rent in Houston TX near HCC - Spring Branch Campus. Enjoy luxury amenities and modern living in the Energy Corridor. ",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-houston-christian-univ",
      "search_query": "Apartments Near Houston Christian University",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston, TX, Near Houston Christian University",
      "h2_subtitle": "NEO at Ten offers convenient living near Houston Christian University in Houston's Energy Corridor. Enjoy modern amenities and stylish apartment features.",
      "page_copy": "Welcome to NEO at Ten, where you can find apartments for rent in Houston, TX, near Houston Christian University. Located in the vibrant Energy Corridor, our community provides easy access to Houston Christian University, making it an ideal choice for students and faculty. Each apartment home features modern finishes such as stainless steel appliances, granite countertops, and pendant lighting, ensuring a luxurious living experience. \n\nResidents enjoy a variety of amenities, including a fitness center, clubhouse, and a serene Zen garden. With one and two-bedroom floor plans available, NEO at Ten offers the perfect blend of comfort and convenience. Our community is designed to meet all your needs, from a business center to an outdoor kitchen for social gatherings. Discover your new home at NEO at Ten and enjoy the best of Houston living, just moments away from Houston Christian University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs.",
        "public_id": "019f6c0f-f7b9-768c-8ae2-d69ffb932d06",
        "storage_key": "property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c10-017c-7669-9381-1165906a63c8",
        "storage_key": "property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "NEO at Ten | Apartments Near Houston Christian University",
      "seo_description": "Explore NEO at Ten's apartments for rent in Houston, TX, near Houston Christian University. Enjoy luxury amenities and modern living in the Energy Corridor. ",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-houston-tx-near-art-institute",
      "search_query": "Apartments For Rent In Houston, TX, Near The Art Institute of Houston",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Houston, TX, Near The Art Institute of Houston",
      "h2_subtitle": "NEO at Ten offers convenient living near The Art Institute of Houston in the Energy Corridor. Enjoy modern amenities and stylish apartment features.",
      "page_copy": "Welcome to NEO at Ten, where you can find apartments for rent in Houston, TX, near The Art Institute of Houston. Located in the vibrant Energy Corridor, our community provides easy access to The Art Institute, making it an ideal choice for students and faculty involved in culinary, design, fashion, and media arts programs. Each apartment home features modern finishes such as stainless steel appliances, granite countertops, and pendant lighting, ensuring a luxurious living experience. \n\nResidents enjoy a variety of amenities, including a fitness center, clubhouse, and a serene Zen garden. With one and two-bedroom floor plans available, NEO at Ten offers the perfect blend of comfort and convenience. Our community is designed to meet all your needs, from a business center to an outdoor kitchen for social gatherings. Discover your new home at NEO at Ten and enjoy the best of Houston living, just moments away from The Art Institute of Houston.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs.",
        "public_id": "019f6c0f-f7b9-768c-8ae2-d69ffb932d06",
        "storage_key": "property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c10-017c-7669-9381-1165906a63c8",
        "storage_key": "property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "NEO at Ten | Apartments Near The Art Institute of Houston",
      "seo_description": "Explore NEO at Ten's apartments for rent in Houston, TX, near The Art Institute of Houston. Enjoy luxury amenities and modern living in the Energy Corridor.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-houston-tx-near-maurice-wolfe",
      "search_query": "Apartments For Rent In Houston, TX, Near Maurice L. Wolfe Elementary",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston, TX, Near Maurice L. Wolfe Elementary",
      "h2_subtitle": "NEO at Ten offers family-friendly living just 0.9 km from Maurice L. Wolfe Elementary in Houston's Energy Corridor. Enjoy modern amenities and spacious floor plans.",
      "page_copy": "Welcome to NEO at Ten, where you can find apartments for rent in Houston, TX, near Maurice L. Wolfe Elementary. Perfectly situated just 0.9 km away, our community is ideal for families seeking proximity to this esteemed public school within the Katy Independent School District. Each apartment home features modern finishes such as stainless steel appliances, granite countertops, and pendant lighting, ensuring a luxurious living experience. \n\nResidents enjoy a variety of amenities, including a fitness center, clubhouse, and a serene Zen garden. With one and two-bedroom floor plans available, NEO at Ten offers the perfect blend of comfort and convenience for families. Our community is designed to meet all your needs, from a business center to an outdoor kitchen for social gatherings. Discover your new home at NEO at Ten and enjoy the best of Houston living, just moments away from Maurice L. Wolfe Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs.",
        "public_id": "019f6c0f-f7b9-768c-8ae2-d69ffb932d06",
        "storage_key": "property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c10-017c-7669-9381-1165906a63c8",
        "storage_key": "property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "NEO at Ten | Apartments Near Maurice L. Wolfe Elementary",
      "seo_description": "Explore NEO at Ten's apartments for rent in Houston, TX, near Maurice L. Wolfe Elementary. Enjoy family-friendly amenities and modern apartment living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-houston-tx-near-memorial-parkway",
      "search_query": "Apartments For Rent In Houston, TX, Near Memorial Parkway Junior High School",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Houston, TX, Near Memorial Parkway Junior High School",
      "h2_subtitle": "NEO at Ten offers family-friendly living near Memorial Parkway Junior High School in Houston's Energy Corridor. Enjoy modern amenities and spacious floor plans.",
      "page_copy": "Welcome to NEO at Ten, where you can find apartments for rent in Houston TX near Memorial Parkway Junior High School. Located just 14 minutes away, our community is ideal for families seeking proximity to this reputable public school within the Katy Independent School District. Each apartment home features modern finishes such as stainless steel appliances, granite countertops, and pendant lighting, ensuring a luxurious living experience. \n\nResidents enjoy a variety of amenities, including a fitness center, clubhouse, and a serene Zen garden. With one and two-bedroom floor plans available, NEO at Ten offers the perfect blend of comfort and convenience for families. Our community is designed to meet all your needs, from a business center to an outdoor kitchen for social gatherings. Discover your new home at NEO at Ten and enjoy the best of Houston living, just a short drive from Memorial Parkway Junior High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs.",
        "public_id": "019f6c0f-f7b9-768c-8ae2-d69ffb932d06",
        "storage_key": "property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c10-017c-7669-9381-1165906a63c8",
        "storage_key": "property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "NEO at Ten | Apts Near Memorial Parkway Junior High School",
      "seo_description": "Explore NEO at Ten's apartments for rent in Houston, TX, near Memorial Parkway Junior High School. Enjoy family-friendly apartment living!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-houston-tx-near-alief-taylor",
      "search_query": "Apartments For Rent In Houston, TX, Near Alief Taylor High School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston, TX, Near Alief Taylor High School",
      "h2_subtitle": "NEO at Ten offers family-friendly living near Alief Taylor High School in Houston's Energy Corridor. Enjoy modern amenities and spacious floor plans.",
      "page_copy": "Welcome to NEO at Ten, where you can find apartments for rent in Houston, TX, near Alief Taylor High School. Located just 10.9 km away, our community is ideal for families seeking proximity to this esteemed public school within the Alief Independent School District. Each apartment home features modern finishes such as stainless steel appliances, granite countertops, and pendant lighting, ensuring a luxurious living experience. \n\nResidents enjoy a variety of amenities, including a fitness center, clubhouse, and a serene Zen garden. With one and two-bedroom floor plans available, NEO at Ten offers the perfect blend of comfort and convenience for families. Our community is designed to meet all your needs, from a business center to an outdoor kitchen for social gatherings. Discover your new home at NEO at Ten and enjoy the best of Houston living, just a short drive from Alief Taylor High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs.",
        "public_id": "019f6c0f-f7b9-768c-8ae2-d69ffb932d06",
        "storage_key": "property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c10-017c-7669-9381-1165906a63c8",
        "storage_key": "property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "NEO at Ten | Apartments Near Alief Taylor High School",
      "seo_description": "Explore NEO at Ten's apartments for rent in Houston, TX, near Alief Taylor High School. ",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5191322281443328",
      "source": "custom",
      "page_item_url": "discover-pet-friendly-apartments-in-houston-neo-at-ten",
      "search_query": "Pet-friendly Apartments in Houston, TX",
      "category": "Pet-Friendly",
      "h1_title": "Discover Pet-friendly Apartments in Houston, TX, at NEO at Ten",
      "h2_subtitle": "NEO at Ten offers a welcoming environment for you and your furry friends. Enjoy spacious floor plans and high-end features in the heart of Houston's Energy Corridor.",
      "page_copy": "Welcome to NEO at Ten, where pet-friendly apartments in Houston, TX, redefine modern living. Located in the vibrant Energy Corridor, our community is designed with both you and your pets in mind. Our spacious floor plans provide ample room for relaxation and play, while our high-end features ensure a comfortable lifestyle. From gourmet kitchens to private balconies, every detail is crafted to enhance your living experience. Plus, our convenient location on Grisby Road means you're just minutes away from parks, shopping, and dining. Discover the perfect blend of luxury and pet-friendly living at NEO at Ten today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs.",
        "public_id": "019f6c0f-f7b9-768c-8ae2-d69ffb932d06",
        "storage_key": "property/5191322281443328/019f6c0f-f7b9-768c-8ae2-d69ffb932d06.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c10-017c-7669-9381-1165906a63c8",
        "storage_key": "property/5191322281443328/019f6c10-017c-7669-9381-1165906a63c8.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "NEO at Ten | Pet-friendly Apartments in Houston, TX",
      "seo_description": "Explore NEO at Ten's pet-friendly apartments in Houston, TX. Enjoy spacious floor plans and high-end features in the Energy Corridor. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2180"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2341588496"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a3c\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a3c\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4960172"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-57VPFZP"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8007438931"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "f12fa71124bda711"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/10pdky97w2z"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "346-601-2928"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im43T2h3MGFRQmJhWFBzVGE2a2Fxc3c9PSIsInZhbHVlIjoib0svY2duNEFTbW4vOE1wQ0pvZEhGZz09IiwibWFjIjoiNzhlNmNkOGQ1MDhmNTc3Nzg1ZWQ5NTcxYTFhMWY4MTEzMmQ1ZTAyZTc1YTU2NzhmMjc1ZjhjOTllODA2NjJhMSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2180",
  "custom_repli_id": "2341588496",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a3c\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a3c\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4960172",
  "custom_google_gtm_id": "GTM-57VPFZP",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8007438931",
  "custom_knock_community_id": "f12fa71124bda711",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/10pdky97w2z",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "346-601-2928",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im43T2h3MGFRQmJhWFBzVGE2a2Fxc3c9PSIsInZhbHVlIjoib0svY2duNEFTbW4vOE1wQ0pvZEhGZz09IiwibWFjIjoiNzhlNmNkOGQ1MDhmNTc3Nzg1ZWQ5NTcxYTFhMWY4MTEzMmQ1ZTAyZTc1YTU2NzhmMjc1ZjhjOTllODA2NjJhMSJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "ec8fad80-6941-47e7-8721-c19e6bd604b3",
  "custom_audioeye_site_hash": "d6ec5b1a4ebe9d76167651c1907c7fff"
};

export const generatedAt = '2026-11-03T20:34:01.338Z';
